import React, { useRef, useState, useEffect } from 'react';
import {
  Grid,
  MenuItem,
  TextField,
  Typography,
  InputLabel,
  Box,
  Button,
  Card,
  Select,
  Icon,
} from '@mui/material';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import routes from "trainerRoutes";
import MKAvatar from "components/MKAvatar";
import editRoutes from "trainerEditRoutes";
import Container from "@mui/material/Container";
import MKBox from "components/MKBox";
import CountryList from 'country-list-with-dial-code-and-flag';
import Logo from "assets/images/skill2.png";
import CompanyIcon from "assets/images/companyicon.png";
import Expectation from "assets/images/team_3082743.png";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MKButton from "components/MKButton";
import { LocationOn } from '@mui/icons-material';
import MKTypography from "components/MKTypography";
import SimpleFooter from "examples/Footers/SimpleFooter";
import { useNavigate } from 'react-router-dom';
import { getAllISOCodes, getAllInfoByISO } from 'iso-country-currency';
import FormControl from '@mui/material/FormControl';
import Modal from "@mui/material/Modal";
import DatePicker from "react-multi-date-picker";
import Breadcrumbs from "examples/Breadcrumbs";
import MKAlert from "components/MKAlert";
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import AWS from 'aws-sdk';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import TrainerTermsAndCondition from './TrainerTermsAndCondition';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import IdleTimeOutHandler from "pages/IdleTimeHandler/IdleTimeOutHander";
import '../../../styles.css';

const LoadingOverlay = ({ loading, children }) => {
  return (
    <>
      {loading && (
        <Backdrop
          sx={{
            color: '#fff',
            zIndex: (theme) => theme.zIndex.drawer + 1,
            filter: 'blur(5px)',
            pointerEvents: 'none',
          }}
          open={loading}
        >
          <Box
            sx={{
              position: "absolute",
              top: "0",
              left: "0",
              zIndex: "1",
              width: "100%",
              minHeight: "100vh",
              // display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              pointerEvents: 'none',
              userSelect: 'none',
            }}
          >
            {children}
          </Box>
        </Backdrop>
      )}
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: (theme) => theme.zIndex.drawer + 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!loading && children}
    </>
  );
};

function CustomMultipleInput({ openCalendar, value }) {
  return (
    <div>
      <input type="hidden"
        onFocus={openCalendar}
        value={value}
        readOnly
      />
      <MKButton variant="gradient" color="info" size="small" style={{ marginLeft: "20px" }} onClick={openCalendar} >Select Dates</MKButton>
    </div>
  )
}


const Page = () => {
  const [agreed, setAgreed] = useState(false);
  const [submitApplyCompleted, setSubmitApplyCompleted] = useState(false);
  const [submitRemainderCompleted, setSubmitRemainderCompleted] = useState(false);
  const [recruitSubmitCompleted, setRecruitSubmitCompleted] = useState(false);
  const [submitAcceptCompleted, setSubmitAcceptCompleted] = useState(false);
  const [submitTrainingAcceptCompleted, setSubmitTrainingAcceptCompleted] = useState(false);
  const [submitConfirmTrainingCompleted, setSubmitConfirmTrainingCompleted] = useState(false);
  const [submitInvoiceSentCompleted, setSubmitInvoiceSentCompleted] = useState(false);
  const [submitPaymentNotReceivedCompleted, setSubmitPaymentNotReceivedCompleted] = useState(false);
  const [submitPaymentReceivedCompleted, setSubmitPaymentReceivedCompleted] = useState(false);
  const [feedbackCompleted, setFeedbackCompleted] = useState(false);
  const [submitCompleted, setSubmitCompleted] = useState(false);
  const [mobileNumber, setMobileNumber] = useState('');
  const [mobileNumberError, setMobileNumberError] = useState(true);
  const [submitMobileCompleted, setSubmitMobileCompleted] = useState(false);
  const [submitOTPCompleted, setSubmitOTPCompleted] = useState(false);
  const [otpValidated, setOtpValidated] = useState(false);
  const [otpValue, setOtpValue] = useState('');
  const [bbdata, setbbdata] = useState([]);
  const [userId, setUserId] = useState("");
  const [dialogCountry, setDialogCountry] = useState('');
  const [dialogCountryCode, setDialogCountryCode] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [resendDisabled, setResendDisabled] = useState(false);
  const [timer, setTimer] = useState(120);
  const [trainerProfileCreate, setTrainerProfileCreate] = useState(false);
  const [trainingList, setTrainingList] = useState([]);
  const [bb1data, setbb1Data] = useState([]);
  const [appliedTrainingDetails, setAppliedTrainingDetails] = useState([]);
  const [trainerRecruitDetails, setTrainerRecruitDetails] = useState([]);
  const [recommendedSkillsDetails, setRecommendedSkillsDetails] = useState([]);
  const [skillErrorMessage, setSkillErrorMessage] = useState('');
  const [maxRemainderCount, setMaxRemainderCount] = useState(false);
  const [maxApplyCount, setMaxApplyCount] = useState(false);

  const [trainerDetails, setTrainerDetails] = useState([]);
  const [avatarBackgroundColor, setAvatarBackgroundColor] = useState('#ccc');
  const [selectedCurrencyCountry, setSelectedCurrencyCountry] = useState('');
  const [commercialsCurrency, setCommercialsCurrency] = useState("");
  const [commercialsLessThan4hrs, setCommercialsLessThan4hrs] = useState("");
  const [commercials4hrs, setCommercials4hrs] = useState("");
  const [commercials8hrs, setCommercials8hrs] = useState("");
  const [lastDeliveredDate, setLastDeliveredDate] = useState("");
  const [lastClient, setLastClient] = useState("");
  const [courseDuration, setCourseDuration] = useState("");
  const [trainingAvailableDate, setTrainingAvailableDate] = useState([]);
  const [callAvailableDate, setCallAvailableDate] = useState([]);
  const [trainingComment, settrainingComment] = useState("");
  const [currency, setCurrency] = useState('');
  const [trainerProfile, setTrainerProfile] = useState("");
  const [selectedTrainingCompanyId, setSelectedTrainingCompanyId] = useState("");
  const [selectedTraining, setSelectedTraining] = useState(null);
  const [selectedTrainingName, setSelectedTrainingName] = useState("");
  const [selectedTrainingID, setSelectedTrainingID] = useState("");
  const [lab, setLab] = useState("");
  const [labCostPerParticipants, setLabCostPerParticipants] = useState("");
  const [serverCount, setServerCount] = useState("");
  const [typeOfServer, setTypeOfServer] = useState("");
  const [responseFromDB, setResponseFromDB] = useState("");
  const [responseFromDBApply, setResponseFromDBApply] = useState("");

  const [emailVerified, setEmailVerified] = useState(false);
  const [mobVerified, setMobVerified] = useState(false);
  const [tcVerified, setTcVerified] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const [feedbackQuestions, setFeedbackQuestions] = useState([]);
  const [feedbackRating, setFeedbackRating] = useState(0);
  const [isFeedback1Interacted, setIsFeedback1Interacted] = useState(false);
  const [feedbackAnswer1, setFeedbackAnswer1] = useState("");
  const [isFeedback2Interacted, setIsFeedback2Interacted] = useState(false);
  const [feedbackAnswer2, setFeedbackAnswer2] = useState("");
  const [isFeedback3Interacted, setIsFeedback3Interacted] = useState(false);
  const [feedbackAnswer3, setFeedbackAnswer3] = useState("");
  const [isFeedback4Interacted, setIsFeedback4Interacted] = useState(false);
  const [feedbackAnswer4, setFeedbackAnswer4] = useState("");
  const [isFeedback5Interacted, setIsFeedback5Interacted] = useState(false);
  const [feedbackAnswer5, setFeedbackAnswer5] = useState("");
  const [isFeedback6Interacted, setIsFeedback6Interacted] = useState(false);
  const [feedbackAnswer6, setFeedbackAnswer6] = useState("");
  const [feedbackStatusAvailable, setFeedbackStatusAvailable] = useState(false);
  const [trainerWithPaymentStatus, setTrainerWithPaymentStatus] = useState([]);
  const [trainerWithPaymentStatus20, setTrainerWithPaymentStatus20] = useState([]);
  const [trainerWithStatus2, setTrainerWithStatus2] = useState([]);
  const [trainerWithStatus5, setTrainerWithStatus5] = useState([]);
  const [trainerWithStatus8, setTrainerWithStatus8] = useState([]);
  const [pendingAction, setPendingAction] = useState([]);
  const [loading, setLoading] = useState(false);

  const [scroll, setScroll] = React.useState("paper");

  const [scrollX, setScrollX] = useState(0);

  const navigate = useNavigate();

  // const handleAppliedScroll = (direction) => {
  //   const container = document.getElementById('applied-training-list-container');
  //   const scrollAmount = direction === 'left' ? -600 : 600;
  //   container.scrollBy({
  //     left: scrollAmount,
  //     behavior: 'smooth',
  //   });
  // };

  const [appliedCurrentSlide, setAppliedCurrentSlide] = useState(0);
  const handleAppliedScroll = (direction) => {
    const totalSlides = Math.ceil(appliedTrainings.length / 2);
    if (direction === 'left') {
      setAppliedCurrentSlide((prevSlide) => (prevSlide === 0 ? totalSlides - 1 : prevSlide - 1));
    } else {
      setAppliedCurrentSlide((prevSlide) => (prevSlide === totalSlides - 1 ? 0 : prevSlide + 1));
    }
  };


  useEffect(() => {
    const container = document.getElementById('applied-training-list-container');
    if (container) {
      container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          handleAppliedScroll('left');
        } else if (e.key === 'ArrowRight') {
          handleAppliedScroll('right');
        }
      });
    }
  }, []);

  // const handleAcceptedScroll = (direction) => {
  //   const container = document.getElementById('accepted-training-list-container');
  //   const scrollAmount = direction === 'left' ? -600 : 600;
  //   container.scrollBy({
  //     left: scrollAmount,
  //     behavior: 'smooth',
  //   });
  // };

  const [acceptedCurrentSlide, setAcceptedCurrentSlide] = useState(0);
  const handleAcceptedScroll = (direction) => {
    const totalSlides = Math.ceil(acceptedTrainings.length / 2);
    if (direction === 'left') {
      setAcceptedCurrentSlide((prevSlide) => (prevSlide === 0 ? totalSlides - 1 : prevSlide - 1));
    } else {
      setAcceptedCurrentSlide((prevSlide) => (prevSlide === totalSlides - 1 ? 0 : prevSlide + 1));
    }
  };

  useEffect(() => {
    const container = document.getElementById('accepted-training-list-container');
    if (container) {
      container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          handleAcceptedScroll('left');
        } else if (e.key === 'ArrowRight') {
          handleAcceptedScroll('right');
        }
      });
    }
  }, []);


  // const handleVanquishedScroll = (direction) => {
  //   const container = document.getElementById('vanquished-training-list-container');
  //   const scrollAmount = direction === 'left' ? -600 : 600;
  //   container.scrollBy({
  //     left: scrollAmount,
  //     behavior: 'smooth',
  //   });
  // };

  const [vanquishedCurrentSlide, setVanquishedCurrentSlide] = useState(0);
  const handleVanquishedScroll = (direction) => {
    const totalSlides = Math.ceil(vanquishedTrainings.length / 2);
    if (direction === 'left') {
      setVanquishedCurrentSlide((prevSlide) => (prevSlide === 0 ? totalSlides - 1 : prevSlide - 1));
    } else {
      setVanquishedCurrentSlide((prevSlide) => (prevSlide === totalSlides - 1 ? 0 : prevSlide + 1));
    }
  };

  useEffect(() => {
    const container = document.getElementById('vanquished-training-list-container');
    if (container) {
      container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          handleVanquishedScroll('left');
        } else if (e.key === 'ArrowRight') {
          handleVanquishedScroll('right');
        }
      });
    }
  }, []);

  // const handleCompletedScroll = (direction) => {
  //   const container = document.getElementById('completed-training-list-container');
  //   const scrollAmount = direction === 'left' ? -600 : 600;
  //   container.scrollBy({
  //     left: scrollAmount,
  //     behavior: 'smooth',
  //   });
  // };

  const [completedCurrentSlide, setCompletedCurrentSlide] = useState(0);
  const handleCompletedScroll = (direction) => {
    const totalSlides = Math.ceil(completedTrainings.length / 2);
    if (direction === 'left') {
      setCompletedCurrentSlide((prevSlide) => (prevSlide === 0 ? totalSlides - 1 : prevSlide - 1));
    } else {
      setCompletedCurrentSlide((prevSlide) => (prevSlide === totalSlides - 1 ? 0 : prevSlide + 1));
    }
  };

  useEffect(() => {
    const container = document.getElementById('completed-training-list-container');
    if (container) {
      container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          handleCompletedScroll('left');
        } else if (e.key === 'ArrowRight') {
          handleCompletedScroll('right');
        }
      });
    }
  }, []);

  const [recommendedCurrentSlide, setRecommendedCurrentSlide] = useState(0);
  const handleRecommendedScroll = (direction) => {
    const totalSlides = Math.ceil(recommendedSkillsDetails.length / 2);
    if (direction === 'left') {
      setRecommendedCurrentSlide((prevSlide) => (prevSlide === 0 ? totalSlides - 1 : prevSlide - 1));
    } else {
      setRecommendedCurrentSlide((prevSlide) => (prevSlide === totalSlides - 1 ? 0 : prevSlide + 1));
    }
  };

  // const handleRecommendedScroll = (direction) => {
  //   const container = document.getElementById('recommended-training-list-container');
  //   const scrollAmount = direction === 'left' ? -600 : 600;
  //   container.scrollBy({
  //     left: scrollAmount,
  //     behavior: 'smooth',
  //   });
  // };

  useEffect(() => {
    const container = document.getElementById('recommended-training-list-container');
    if (container) {
      container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          handleRecommendedScroll('left');
        } else if (e.key === 'ArrowRight') {
          handleRecommendedScroll('right');
        }
      });
    }
  }, []);

  // const handleRecuritScroll = (direction) => {
  //   const container = document.getElementById('recurit-training-list-container');
  //   const scrollAmount = direction === 'left' ? -600 : 600;
  //   container.scrollBy({
  //     left: scrollAmount,
  //     behavior: 'smooth',
  //   });
  // };

  const [recuritCurrentSlide, setRecuritCurrentSlide] = useState(0);
  const handleRecuritScroll = (direction) => {
    const totalSlides = Math.ceil(trainerRecruitDetails.length / 2);
    if (direction === 'left') {
      setRecuritCurrentSlide((prevSlide) => (prevSlide === 0 ? totalSlides - 1 : prevSlide - 1));
    } else {
      setRecuritCurrentSlide((prevSlide) => (prevSlide === totalSlides - 1 ? 0 : prevSlide + 1));
    }
  };

  useEffect(() => {
    const container = document.getElementById('recurit-training-list-container');
    if (container) {
      container.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          handleRecuritScroll('left');
        } else if (e.key === 'ArrowRight') {
          handleRecuritScroll('right');
        }
      });
    }
  }, []);


  const handleCountryChange = (event) => {
    const selectedCountry = event.target.value;
    setSelectedCountry(selectedCountry);
    const country = CountryList.getAll().find((c) => c.name === selectedCountry);
    if (country) {
      setCountryCode(country.dialCode);
    }
    setDialogCountry(selectedCountry);
    setDialogCountryCode(country ? country.dial_code : '');
  };

  const handleMobileNumberChange = (e, setValidation) => {
    const input = e.target.value;
    const regex = /^[0-9]+$/;
    const isValid = regex.test(input);
    setMobileNumberError(isValid);
  };

  const logout = () => {
    localStorage.clear();
    window.localStorage.clear();
    window.location.href = "/portal";
  };

  const createProfile = () => {
    window.location.href = "/app/trainerprofile";
  };

  const trainingsList = () => {
    window.location.href = "/app/traininglist";
  };

  const OnOkClick = (e) => {
    setLoading(true);
    const data = {
      is_verified_tc: agreed,
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/verifytc/${userId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          console.log("new1submitCompleted", submitCompleted);
          setSubmitCompleted(false);
          setLoading(false);
        }
        return response.json();
      })
      .then((data) => {
        setErrorMsg(data.message);
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        setErrorMsg(data.message);
        console.log("oooooooooooooooo");
      });

    console.log('Form submitted!');
  };
  console.log("newsubmitCompleted", submitCompleted);

  console.log(agreed);

  const handleMobNumSubmit = () => {
    setLoading(true);
    const data = {
      mobile_number: countryCode + mobileNumber,
      user_id: userId,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/send-otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          console.log("response11111111111", response);
          console.log('aaaaaaaaaaa');
          setSubmitOTPCompleted(true);
        }
        setLoading(false);
        return response.json();
      })
      .then((data) => {
        setErrorMsg(data.message);
        console.log(data.message);
        console.log('fffffffffffffffff');
      })
      .catch((error) => {
        console.log('oooooooooooooooo');
      });
  };

  const handleValidateSubmit = () => {
    setLoading(true);
    const data = {
      mobile_number: countryCode + mobileNumber,
      otp: otpValue,
      user_id: userId,
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/verify-otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          console.log("response11111111111", response);
          console.log('aaaaaaaaaaa');
          setSubmitMobileCompleted(false);
          setOtpValidated(true);
        }
        return response.json();
        setLoading(false);
      })
      .then((data) => {
        console.log(data);
        setErrorMsg(data.message);
        console.log('fffffffffffffffff');
      })
      .catch((error) => {
        console.log('oooooooooooooooo');
      });
  };

  const [emailErrorMessage, setEmailErrorMessage] = useState('');

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    setUserId(id);
    fetch(`${process.env.REACT_APP_API_URL}/api/userdetails/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setbbdata(data);
          setEmailVerified(data.is_verified);
          setMobVerified(data.is_verified_mobile);
          setTcVerified(data.is_verified_tc);
          if (JSON.parse(data.is_verified_tc) === false) {
            setSubmitCompleted(true);
            console.log("HI");
          } else if (JSON.parse(data.is_verified_tc) === true) {
            console.log("222222");
            setSubmitCompleted(false);
            if (JSON.parse(data.is_verified_mobile) === false) {
              console.log("333333");
              setSubmitMobileCompleted(true);
            }
            else {
              console.log("44444444");
              setSubmitMobileCompleted(false);
            }
          }
        }
      })
      .catch((error) => {
        console.error(error);
        setEmailErrorMessage(error);
      });
  }, [localStorage.getItem("token"), submitCompleted]);
  console.log("bbbbbbbbbbbb", bbdata);

  useEffect(() => {
    if (submitOTPCompleted && !otpValidated) {
      startTimer();
    }
  }, [submitOTPCompleted, otpValidated]);

  const startTimer = () => {
    let timeLeft = 60;
    setTimer(timeLeft);

    const timerInterval = setInterval(() => {
      timeLeft -= 1;
      setTimer(timeLeft);

      if (timeLeft === 0) {
        clearInterval(timerInterval);
        setResendDisabled(false);
      }
    }, 1000);

    setResendDisabled(true);
  };

  function formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedTime = `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    return formattedTime;
  }

  const handleResendOTP = () => {
    setLoading(true);
    const data = {
      mobile_number: countryCode + mobileNumber,
      user_id: userId,
    };
    fetch(`${process.env.REACT_APP_API_URL}/api/resend-otp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          console.log('aaaaaaaaaaa');
          setLoading(false);
        }
        return response.json();
      })
      .then((data) => {
        setErrorMsg(data.message);
        console.log(data.message);
        console.log('fffffffffffffffff');
      })
      .catch((error) => {
        console.log('oooooooooooooooo');
      });
  };

  const handleDialogClose = () => {
    window.location.reload();
  };

  const handleOTPDialogClose = () => {
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerprofileuidexists/${userId}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.exists === false) {
          setSubmitOTPCompleted(false);
          setTrainerProfileCreate(true);
          window.location.href = "/app/trainerprofile";
        } else {
          setTrainerProfileCreate(false);
          window.location.reload();
        }
      })
      .catch(error => {
        console.error("Error fetching data:", error);
      });
  };

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log("iddddddddddddd", id);
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerprofileuidexists/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then(response => response.json())
      .then(data => {
        if (data.exists === false && mobVerified === true && tcVerified === true && emailVerified === true) {
          setTrainerProfileCreate(true);
          window.location.href = "/app/trainerprofile";
        } else {
          console.log("hiiiiiiiiiiiiii", data.exists);
          setTrainerProfileCreate(false);
        }
      })
      .catch(error => {
        console.error("Error fetching data:", error);
      });
  }, [localStorage.getItem("userId"), mobVerified, tcVerified, emailVerified]);
  console.log("trainerProfileCreate", trainerProfileCreate);


  useEffect(() => {
    let id = localStorage.getItem("userId");
    fetch(`${process.env.REACT_APP_API_URL}/api/pending-action-get/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data) {
          setPendingAction(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [localStorage.getItem("userId")])

  console.log("pendingAction", pendingAction);

  const [trainerWithPayment, setTrainerWithPayment] = useState(false);
  const [trainerWithPayment20, setTrainerWithPayment20] = useState(false);
  const [trainerWith2, setTrainerWith2] = useState(false);
  const [trainerWith5, setTrainerWith5] = useState(false);
  const [trainerWith8, setTrainerWith8] = useState(false);
  const [trainingCompanyDetails, setTrainingCompanyDetails] = useState("");
  const [s3BucketURL, setS3BucketURL] = useState(null);
  const [tocS3BucketURL, setTocS3BucketURL] = useState(null);


  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "nocard";
    let filterStatus = "nofilter";
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-applied-training/${id}/${filterStatus}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setAppliedTrainingDetails(data);

          // Clear previous data
          setTrainerWithStatus2([]);
          setTrainerWithStatus5([]);
          setTrainerWithStatus8([]);
          setTrainerWithPaymentStatus([]);
          setTrainerWithPaymentStatus20([]);

          data.forEach((trainer) => {
            const status = parseInt(trainer.applyTrainingStatus);

            if (status === 2) {
              console.log("1");
              setTrainerWith2(true);
              setTrainerWithStatus2((prev) => [...prev, trainer]);
            } else if (status === 5) {
              console.log("2");
              setTrainerWith5(true);
              setTrainerWithStatus5((prev) => [...prev, trainer]);
            } else if (status === 8) {
              console.log("3");
              setTrainerWith8(true);
              setTrainerWithStatus8((prev) => [...prev, trainer]);
            } else if (status === 10) {
              console.log("4");
              setTrainerWithPayment(true);
              setTrainerWithPaymentStatus((prev) => [...prev, trainer]);
            } else if (status === 20) {
              console.log("5");
              setTrainerWithPayment20(true);
              setTrainerWithPaymentStatus20((prev) => [...prev, trainer]);
            }
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [userId]);
  console.log("appliedTrainingDetails", appliedTrainingDetails);
  console.log("trainerWithPayment", trainerWithPayment);
  console.log("trainerWithPaymentStatus", trainerWithPaymentStatus);
  console.log("trainerWithPayment20", trainerWithPayment20);
  console.log("trainerWithPaymentStatus20", trainerWithPaymentStatus20);

  console.log("trainerWithStatus2", trainerWithStatus2);
  console.log("trainerWithStatus5", trainerWithStatus5);
  console.log("trainerWithStatus8", trainerWithStatus8);

  const [appliedTrainings, setAppliedTrainings] = useState([]);
  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "card";
    let filterStatus = "appliedTrainings";
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-applied-training/${id}/${filterStatus}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setAppliedTrainings(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [userId, appliedTrainingDetails]);
  console.log("appliedTrainings", appliedTrainings);

  const [acceptedTrainings, setAcceptedTrainings] = useState([]);
  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "card";
    let filterStatus = "acceptedTrainings";
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-applied-training/${id}/${filterStatus}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setAcceptedTrainings(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [userId, appliedTrainingDetails]);
  console.log("acceptedTrainings", acceptedTrainings);

  const [vanquishedTrainings, setVanquishedTrainings] = useState([]);
  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "card";
    let filterStatus = "vanquishedTrainings";
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-applied-training/${id}/${filterStatus}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setVanquishedTrainings(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [userId, appliedTrainingDetails]);
  console.log("vanquishedTrainings", vanquishedTrainings);

  const [completedTrainings, setCompletedTrainings] = useState([]);
  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "card";
    let filterStatus = "completedTrainings";
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-applied-training/${id}/${filterStatus}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setCompletedTrainings(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [userId, appliedTrainingDetails]);
  console.log("completedTrainings", completedTrainings);

  AWS.config.update({
    accessKeyId: process.env.REACT_APP_S3_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_S3_AWS_SECRET_ACCESS_KEY,
    region: process.env.REACT_APP_S3_REGION,
  });

  useEffect(() => {
    if (trainerWithPaymentStatus20 && trainerWithPaymentStatus20.length > 0 && trainerWithPaymentStatus20[0]) {
      let id = trainerWithPaymentStatus20[0].trainingCompanyUserID;

      fetch(`${process.env.REACT_APP_API_URL}/api/userdetails/${id}/`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((resp) => resp.json())
        .then((data) => {
          if (data) {
            setTrainingCompanyDetails(data);
            let bucketURL = `trainingcompanyhub/${id}_${data.username}`;
            setS3BucketURL(bucketURL);
          }
        })
        .catch((error) => {
          console.error(error);
          setEmailErrorMessage(error);
        });
    }
  }, [trainerWithPaymentStatus20]);


  console.log("trainingcompanyDetails", trainingCompanyDetails);
  console.log("s3BucketURL", s3BucketURL);

  const handlePaymentProofDownloadClick = (trainer) => {
    window.location.href = `${process.env.REACT_APP_API_URL}/api/download/${s3BucketURL}/payment-proof/${trainer.trainingName}_paymentProof`;
  };

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "card";
    fetch(`${process.env.REACT_APP_API_URL}/api/dashboard-trainer-recruit/${id}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setTrainerRecruitDetails(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [userId]);
  console.log("trainerRecruitDetails", trainerRecruitDetails);

  useEffect(() => {
    let id = localStorage.getItem("userId");
    console.log(id);
    let display = "card";
    fetch(`${process.env.REACT_APP_API_URL}/api/trainer-skills-equvalent/${id}/${display}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setSkillErrorMessage(data.message);
          if (!data.message) {
            setRecommendedSkillsDetails(data);
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, [userId]);
  console.log("recommendedSkillsDetails", recommendedSkillsDetails);
  console.log("skillErrorMessage", skillErrorMessage);

  useEffect(() => {
    setErrorMsg("");
  }, [submitOTPCompleted, otpValidated])

  useEffect(() => {
    let id = localStorage.getItem("userId");
    setUserId(id);
    fetch(`${process.env.REACT_APP_API_URL}/api/trainer-profile-list/${id}/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          setTrainerDetails(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);
  console.log("trainerDetails", trainerDetails);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/feedback-template-view/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
        } else {
          const trainerFeedbackQuestions = data.filter(
            (question) => question.toWhom === "Trainer"
          );
          setFeedbackQuestions(trainerFeedbackQuestions);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  console.log("feedbackQuestions", feedbackQuestions);

  const handleRatingChange = (event, newValue) => {
    setFeedbackRating(newValue);
  };

  console.log("feedbackRating", feedbackRating);
  console.log("feedbackAnswer1", feedbackAnswer1);
  console.log("feedbackAnswer2", feedbackAnswer2);

  const handleCountryCurrencyChange = (event) => {
    const selectedISO = event.target.value;
    setSelectedCurrencyCountry(selectedISO);

    const currencyInfo = getAllInfoByISO(selectedISO);
    setCurrency(`${currencyInfo.currency} (${currencyInfo.symbol})`);
  };

  console.log("currency", currency);

  const today = new Date().toISOString().split('T')[0];
  const handleLastDeliveredDateChange = (e) => {
    setLastDeliveredDate(e.target.value);
  };
  console.log("lastDeliveredDate", lastDeliveredDate);

  const handleTrainingAvailableChange = (selectedDates) => {
    const formattedDates = selectedDates.map((date) => {
      return date.format('YYYY-MM-DD');
    });

    setTrainingAvailableDate(formattedDates);
  };

  console.log("trainingAvailableDate", trainingAvailableDate);

  const handleCallAvailableDateChange = (selectedDates) => {
    const formattedDates = selectedDates.map((date) => {
      return date.format('YYYY-MM-DD');
    });

    setCallAvailableDate(formattedDates);
  };
  console.log("callAvailableDate", callAvailableDate);


  const handleTrainingProfileChange = (e) => {
    const selectedProfile = e.target.value;
    setTrainerProfile(selectedProfile);

    const experienceArray = trainerDetails.trainingExperience;

    const selectedExperience = experienceArray.find(
      (experience) => experience.profileName === selectedProfile
    );
    if (selectedExperience) {
      setCommercialsLessThan4hrs(selectedExperience.forLessThan4hrs || "");
      setCommercials4hrs(selectedExperience.for4hrs || "");
      setCommercials8hrs(selectedExperience.for8hrs || "");
      setCommercialsCurrency(selectedExperience.commercialsCurrency || "");
      setLastDeliveredDate(selectedExperience.dateOfLastTraining || "");
      setLastClient(selectedExperience.clientDelivered || "");
      setSelectedCurrencyCountry(selectedExperience.selectedCommercialsCurrency || "");
      setCourseDuration(selectedExperience.trainingDuration || "");
    }
  };

  const onApplyClick = (training) => {
    setMaxApplyCount(false);
    setLoading(true);
    let id = localStorage.getItem("userId");
    console.log("userId", id);
    let name = training.trainingName;
    let trainingId = training.trainingID.toString();
    setSelectedTrainingName(name);
    setSelectedTrainingID(trainingId);
    let permiumStatus = trainerDetails.premiumStatus;

    fetch(`${process.env.REACT_APP_API_URL}/api/single-training-details/${trainingId}/${id}/${permiumStatus}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail && data.message === "User not found") {
          console.log("123333333333333333333333333333");
          console.log("details", data.message);
          let companyID = data.trainingCompanyUserID;
          setSelectedTrainingCompanyId(companyID);
          setShowModal(true);
          setLoading(false);
        } else if (data.message === "Remainder reached maximum for the day") {
          console.log("123123123123");
          setMaxApplyCount(true);
          setLoading(false);
        } else {
          console.log("data inside1111111", data);
          let companyID = data.trainingCompanyUserID;
          setSelectedTrainingCompanyId(companyID);
          setShowModal(true);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  console.log("selectedTrainingName", selectedTrainingName);
  console.log("selectedTrainingID", selectedTrainingID);
  console.log("selectedTrainingCompanyId", selectedTrainingCompanyId);

  const onCloseApplyClick = () => {
    setLoading(false);
    setShowModal(false);
    setCommercialsLessThan4hrs("");
    setCommercials4hrs("");
    setCommercials8hrs("");
    setLab("");
    setServerCount("");
    setTypeOfServer("");
    setLabCostPerParticipants("");
    setTrainingAvailableDate("");
    setCallAvailableDate("");
    setCourseDuration("");
    setLastDeliveredDate("");
    setLastClient("");
    settrainingComment("");
    setTrainerProfile("");
    setSelectedCurrencyCountry("");
    setCurrency("");
    setToc(null);
    setSelectionToc("");
  };

  useEffect(() => {
    let userName = localStorage.getItem("user");
    let id = localStorage.getItem("userId");
    let bucketURL = `trainerhub/${id}_${userName}`;
    setTocS3BucketURL(bucketURL);
  }, [])

  const [selectionToc, setSelectionToc] = useState("");

  const handleTocChange = (e) => {
    setSelectionToc(e.target.value);
  };
  console.log("selectionToc", selectionToc);

  const [toc, setToc] = useState(null);

  const [tocError, setTocError] = useState(null);

  const tocFileInputRef = useRef(null);

  const handleUploadClick = () => {
    tocFileInputRef.current.click();
  };

  const handleTocUploadChange = (event) => {
    const selectedFile = event.target.files[0];
    const fileExtension = selectedFile.name.split('.').pop();

    if (selectedFile) {
      const allowedFormats = ['pdf', 'docx', 'xlsx', 'xls'];

      if (!allowedFormats.includes(fileExtension.toLowerCase())) {
        setTocError("Please check the file format.");
        return;
      }

      if (selectedFile.size > 5 * 1024 * 1024) {
        setTocError("File size should be maximum 5mb.");
        return;
      }

      setTocError(null);
      const renamedFile = new File([selectedFile], `${selectedTrainingName}_${selectedTrainingID}_toc.${fileExtension}`, { type: selectedFile.type });
      setToc(renamedFile);
    }
  };

  console.log("toc", toc);

  const onSaveApplyClick = async (e) => {
    setLoading(true);
    try {
      const data = {
        appliedTrainerID: userId,
        selectedTrainingID: selectedTrainingID,
        selectedTrainingName: selectedTrainingName,
        trainingCompanyUserID: selectedTrainingCompanyId,
        profileName: trainerProfile,
        applyToc: selectionToc,
        tocURL: tocS3BucketURL,
        currency: commercialsCurrency,
        commercialsForLessThan4hrs: commercialsLessThan4hrs,
        commercialsFor4hrs: commercials4hrs,
        commercialsFor8hrs: commercials8hrs,
        labsByTrainer: lab,
        serverCount: serverCount,
        typeOfServer: typeOfServer,
        labCostPerParticipants: labCostPerParticipants,
        availableDatesForTraining: trainingAvailableDate,
        availableDatesForCall: callAvailableDate,
        courseDurationHRS: courseDuration,
        recentLastDeliveredDate: lastDeliveredDate,
        recentLastDeliveredClient: lastClient,
        comments: trainingComment,
        premiumStatus: trainerDetails.premiumStatus,
        applyTrainingStatus: "1",
      };
      console.log(JSON.stringify(data));
      setLoading(true);
      setShowModal(false);

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/apply-training/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(data),
      });

      if (response.ok && toc) {
        const formData = new FormData();
        formData.append('files', toc);

        console.log("formData", formData);
        console.log("s3BucketURL", tocS3BucketURL);

        fetch(`${process.env.REACT_APP_API_URL}/api/upload/${tocS3BucketURL}/applytraining/`, {
          method: 'POST',
          body: formData,
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
          })
          .catch(error => {
            console.error('Error uploading file:', error);
          });
        console.log("Toc uploaded successfully");
        setShowModal(false);
        setSubmitApplyCompleted(true);
        setLoading(false);
      } else if (response.ok && !toc) {
        setShowModal(false);
        setSubmitApplyCompleted(true);
        setLoading(false);
      } else {
        setShowModal(false);
        setSubmitApplyCompleted(false);
        throw new Error("Profile is not created. Something went wrong");
      }
      // setSubmitCompleted(true);
    } catch (error) {
      console.log("Error:", error.message);
      setSubmitApplyCompleted(false);
    }
  };


  const DialogProfileApplyClose = () => {
    setShowModal(false);
    window.location.href = "/app/trainerdashboard";
  };

  const onSkillsMoreDetails = (training) => {
    // console.log("training",training.trainingID);
    navigate(`/app/trainingdetails/${training.trainingID}/`);
  };

  const onAppliedMoreDetailsClick = (training) => {
    console.log("training", training.appliedTrainingID);
    navigate(`/app/appliedtrainingmoredetails/${training.appliedTrainingID}/`);
  };

  const onRecruitedTrainingCompanyMoreDetails = (training) => {
    console.log("training", training.trainerRecruitID);
    navigate(`/app/recruitedtrainingcompanymoredetails/${training.trainerRecruitID}/`);
  };

  function getStatus(trainingCompanyRecruitStatus, trainerAcceptStatus, trainingCompanyAgreeStatus) {
    if (trainingCompanyRecruitStatus === "Yes" && trainerAcceptStatus === null && trainingCompanyAgreeStatus === null) {
      return "Awaiting for Your response";
    } else if (trainingCompanyRecruitStatus === "Yes" && trainerAcceptStatus === "Accept" && trainingCompanyAgreeStatus === null) {
      return "Awaiting for Training Partner's response";
    } else if (trainingCompanyRecruitStatus === "Yes" && trainerAcceptStatus === "Decline" && trainingCompanyAgreeStatus === null) {
      return "You have Declined the Training Partner's request";
    } else if (trainingCompanyRecruitStatus === "Yes" && trainerAcceptStatus === "Accept" && trainingCompanyAgreeStatus === "Accept") {
      return "Mutually agreed for the training";
    } else if (trainingCompanyRecruitStatus === "Yes" && trainerAcceptStatus === "Accept" && trainingCompanyAgreeStatus === "Decline") {
      return "Trainer has been rejected";
    } else {
      return "Status not available";
    }
  }

  function getFeedbackStatus(training) {
    let trainerId = training.appliedTrainerID;
    let trainingCompanyID = training.trainingCompanyUserID;
    let trainingID = training.id.toString();
    let toWhom = "TrainingCompany";

    fetch(`${process.env.REACT_APP_API_URL}/api/check-feedback-exists/${trainerId}/${trainingCompanyID}/${trainingID}/${toWhom}/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data) {
          console.log("Data is true", data);
          setFeedbackStatusAvailable(false);
        } else {
          console.log("Data is false or undefined", data);
          setFeedbackStatusAvailable(true);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  console.log("feedbackStatusAvailable", feedbackStatusAvailable);

  // const appliedTrainings = appliedTrainingDetails.filter(training => ["1", "2", "3", "4", "13", "14"].includes(training.applyTrainingStatus));
  // const acceptedTrainings = appliedTrainingDetails.filter(training => ["5", "6", "7", "8", "9", "10", "12", "17", "18", "19", "20"].includes(training.applyTrainingStatus));
  // const vanquishedTrainings = appliedTrainingDetails.filter(training => ["16"].includes(training.applyTrainingStatus));
  // const completedTrainings = appliedTrainingDetails.filter(training => ["11"].includes(training.applyTrainingStatus));

  function getStatusMessage(training) {
    console.log("training.applyTrainingStatus", training.applyTrainingStatus);
    if (training.applyTrainingStatus === "1") {
      return "Awaiting For Training Partner's response";
    } else if (training.applyTrainingStatus === "2") {
      return "Training Partner - Accepted. Awaiting for your response";
    } else if (training.applyTrainingStatus === "13") {
      return "Training Partner has Declined your request";
    } else if (training.applyTrainingStatus === "3") {
      return "Mutually agreed for the training";
    } else if (training.applyTrainingStatus === "14") {
      return "Trainer Declined the training";
    } else if (training.applyTrainingStatus === "4") {
      return "Discussion on-going with Training Partner";
    } else if (training.applyTrainingStatus === "5") {
      return "Training Scheduled - Awaiting for your Confirmation";
    } else if (training.applyTrainingStatus === "6") {
      return "Training Scheduling confirmed with Training Partner";
    } else if (training.applyTrainingStatus === "7") {
      return "Training has been Started";
    } else if (training.applyTrainingStatus === "8") {
      return "Training has been Completed";
    } else if (training.applyTrainingStatus === "9") {
      return "Invoice sent to the Training Partner";
    } else if (training.applyTrainingStatus === "10") {
      return "Payment Completed by the Training Partner";
    } else if (training.applyTrainingStatus === "11") {
      return "Training Completed and Payment Received";
    } else if (training.applyTrainingStatus === "12") {
      return "Payment not Received by the Trainer";
    } else if (training.applyTrainingStatus === "16") {
      return "Your training request is on-hold by Training Partner";
    } else if (training.applyTrainingStatus === "17") {
      return "1st New Payment Date given by Training Partner";
    } else if (training.applyTrainingStatus === "18") {
      return "2nd New Payment Date given by Training Partner";
    } else if (training.applyTrainingStatus === "19") {
      return "Final New Payment Date given by Training Partner";
    } else if (training.applyTrainingStatus === "20") {
      return "Final Completed by the Training Partner";
    } else {
      return "Unknown Status";
    }
  }

  console.log("showFeedbackModal", showFeedbackModal);

  const onRemainderClick = (training) => {
    console.log("training", training);
    console.log("remaindertraining", training.appliedTrainingID);
    setLoading(true);
    setMaxRemainderCount(false);
    // console.log("remaindertraining", training.appliedTrainingID);
    const data = {
      id: training.appliedTrainingID,
      premiumStatus: trainerDetails.premiumStatus,
    };
    console.log("data", JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/apply-training-reminder/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          setSubmitRemainderCompleted(false);
          throw new Error("Profile is not created. Something went wrong");
        }
      })
      .then((data) => {
        console.log("Response from backend:", data.message);
        if (data.message === "Remainder reached maximum for the day") {
          setResponseFromDB(data.message);
          setMaxRemainderCount(true);
          setLoading(false);
        } else if (data.message === "We have re-sent you a link to the company to accept your request") {
          setResponseFromDB(data.message);
          setSubmitRemainderCompleted(true);
          setLoading(false);
        } else {
          setResponseFromDB(data.message);
          setSubmitRemainderCompleted(false);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("Error:", error.message);
      });
  };

  const DialogProfileClose = () => {
    setSubmitRemainderCompleted(false);
    window.location.href = "/app/trainerdashboard";
  };

  const DialogFeebackClose = () => {
    setFeedbackCompleted(false);
    setShowFeedbackModal(false);
    setFeedbackStatusAvailable(false);
    // window.location.href = "/app/trainerdashboard";
  };

  const onAgreeClick = (training) => {
    setLoading(true);
    console.log("111111111111111111", training);
    const data = {
      applyTrainingStatus: "3",
      previousStatus: "2",
      appliedTrainerID: training.appliedTrainerID,
      trainingCompanyUserID: training.trainingCompanyUserID,
      selectedTrainingID: training.id,
      selectedTrainingName: training.trainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitTrainingAcceptCompleted(true);
          setLoading(false);
        } else {
          setSubmitTrainingAcceptCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const onConfirmTrainingClick = (training) => {
    setLoading(true);
    console.log("111111111111111111", training);
    const data = {
      applyTrainingStatus: "6",
      previousStatus: "5",
      appliedTrainerID: training.appliedTrainerID,
      trainingCompanyUserID: training.trainingCompanyUserID,
      selectedTrainingID: training.id,
      selectedTrainingName: training.trainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitConfirmTrainingCompleted(true);
          setLoading(false);
        } else {
          setSubmitConfirmTrainingCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const onSubmitFeedbackClick = (training) => {
    setLoading(true);
    const data = {
      trainerID: training.appliedTrainerID,
      trainingCompanyID: training.trainingCompanyUserID,
      trainingID: training.id.toString(),
      toWhom: "TrainingCompany",
      rating1: feedbackRating,
      question1: feedbackAnswer1,
      question2: feedbackAnswer2,
      question3: feedbackAnswer3,
      question4: feedbackAnswer4,
      question5: feedbackAnswer5,
      question6: feedbackAnswer6,
      status: "Active",
    };

    fetch(`${process.env.REACT_APP_API_URL}/api/feedback-api-view/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          console.log("Feedback submitted successfully");
          setFeedbackCompleted(true);
          setShowFeedbackModal(false);
          setTrainerWithPayment20(false);
          // After feedback is submitted successfully, perform the status update
          const statusUpdateData = {
            applyTrainingStatus: "11",
            previousStatus: "10",
            appliedTrainerID: training.appliedTrainerID,
            trainingCompanyUserID: training.trainingCompanyUserID,
            selectedTrainingID: training.id,
            selectedTrainingName: training.trainingName,
          };

          return fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(statusUpdateData),
          });
        } else {
          setFeedbackCompleted(false);
          throw new Error("Feedback not submitted. Something went wrong");
        }
      })
      .then((statusUpdateResponse) => {
        if (statusUpdateResponse.ok) {
          console.log("Status update completed successfully");
          setShowFeedbackModal(false);
          setTrainerWithPayment(false);
          setTrainerWithPayment20(false);
          setSubmitPaymentReceivedCompleted(true);
          setLoading(false);
        } else {
          setSubmitPaymentReceivedCompleted(false);
          throw new Error("Status update failed. Something went wrong");
        }
      })
      .catch((error) => {
        console.log("Error:", error.message);
      });
  };



  const onSendInvoiceClick = (training) => {
    setLoading(true);
    console.log("111111111111111111", training);
    const data = {
      applyTrainingStatus: "9",
      previousStatus: "8",
      appliedTrainerID: training.appliedTrainerID,
      trainingCompanyUserID: training.trainingCompanyUserID,
      selectedTrainingID: training.id,
      selectedTrainingName: training.trainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitInvoiceSentCompleted(true);
          setLoading(false);
        } else {
          setSubmitInvoiceSentCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const onPaymentReceivedClick = (training) => {
    if (feedbackStatusAvailable && (parseInt(training.applyTrainingStatus) === 10 || parseInt(training.applyTrainingStatus) === 12 || parseInt(training.applyTrainingStatus) === 17 || parseInt(training.applyTrainingStatus) === 18 || parseInt(training.applyTrainingStatus) === 19 || parseInt(training.applyTrainingStatus) === 20)) {
      setShowFeedbackModal(true);
    }
  };

  const onPaymentNotReceivedClick = (training) => {
    setLoading(true);
    setTrainerWithPayment(false);
    setTrainerWithPayment20(false);
    console.log("111111111111111111", training);
    const data = {
      applyTrainingStatus: "12",
      previousStatus: training.applyTrainingStatus,
      appliedTrainerID: training.appliedTrainerID,
      trainingCompanyUserID: training.trainingCompanyUserID,
      selectedTrainingID: training.id,
      selectedTrainingName: training.trainingName,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setSubmitPaymentNotReceivedCompleted(true);
          setLoading(false);
        } else {
          setSubmitPaymentNotReceivedCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };


  const DialogProfileAcceptClose = () => {
    setSubmitAcceptCompleted(false);
    window.location.href = "/app/trainerdashboard";
  };

  const DialogProfileTrainingAcceptClose = () => {
    setSubmitTrainingAcceptCompleted(false);
    window.location.href = "/app/trainerdashboard";
  };

  const DialogProfileConfirmTrainingClose = () => {
    setSubmitConfirmTrainingCompleted(false);
    window.location.href = "/app/trainerdashboard";
  };

  const DialogProfileInvoiceSentClose = () => {
    setSubmitInvoiceSentCompleted(false);
    window.location.href = "/app/trainerdashboard";
  };

  const DialogProfilePaymentNotReceivedClose = () => {
    setSubmitPaymentNotReceivedCompleted(false);
    window.location.href = "/app/trainerdashboard";
  };

  const DialogProfilePaymentReceivedClose = () => {
    setSubmitPaymentReceivedCompleted(false);
    window.location.href = "/app/trainerdashboard";
  };

  const onRecruitAgreeClick = (company) => {
    setLoading(true);
    console.log("2222222222", company);
    const data = {
      trainerAcceptStatus: "Accept",
      trainingCompanyID: company.user_id,
      trainerID: company.trainerID,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/redir-trainerdashboard-status-intodb/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),

    })
      .then((response) => {
        if (response.ok) {
          console.log("aaaaaaaaaaa");
          setRecruitSubmitCompleted(true);
          setLoading(false);
        } else {
          setRecruitSubmitCompleted(false);
          throw new Error("Response not posted. Something went wrong");
        }
      })
      .then((data) => {
        console.log("fffffffffffffffff");
      })
      .catch((error) => {
        console.log("oooooooooooooooo", error.message);
      });
  };

  const DialogProfileRecruitAcceptClose = () => {
    setRecruitSubmitCompleted(false);
    window.location.href = "/app/trainerdashboard";
  };

  const onRecruitRemainderClick = (training) => {
    setLoading(true);
    setMaxRemainderCount(false);
    console.log("recruitRemainder", training.trainerRecruitID);
    const data = {
      id: training.trainerRecruitID,
      premiumStatus: trainerDetails.premiumStatus,
    };
    console.log(JSON.stringify(data));
    fetch(`${process.env.REACT_APP_API_URL}/api/redir-company-status-intodb-reminder/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          setSubmitRemainderCompleted(false);
          throw new Error("Profile is not created. Something went wrong");
        }
      })
      .then((data) => {
        console.log("Response from backend:", data.message);
        if (data.message === "Remainder reached maximum for the day") {
          setResponseFromDB(data.message);
          setMaxRemainderCount(true);
          setLoading(false);
        } else if (data.message === "Trainer's Accept/ Decline status successfully updated in DB" || data.message === "count update and date updated, mail sent") {
          setResponseFromDB(data.message);
          setSubmitRemainderCompleted(true);
          setLoading(false);
        } else {
          setResponseFromDB(data.message);
          setSubmitRemainderCompleted(false);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log("Error:", error.message);
      });
  };

  console.log("responseFromDB", responseFromDB);


  const handlePrivacyPolicyClick = () => {
    window.open('https://www.zippyops.com/privacy-policy', '_blank');
  };

  return (
    <>
      <LoadingOverlay loading={loading}>
        <IdleTimeOutHandler />
        <DefaultNavbar
          routes={trainerProfileCreate ? routes : editRoutes}
          sticky
        />
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mt: -8,
            mb: 4,
            // backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
            // backgroundColor: "#FFFFFF",
            backdropFilter: "saturate(200%) blur(30px)",
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <Container>
            <Grid container>
              <Grid item xs={12} style={{ marginTop: "150px" }}>
                <div>
                  {trainerWithPayment && trainerWithPaymentStatus.map((trainer, index) => (
                    <Modal open={trainerWithPayment} BackdropClick="ignore" sx={{ display: "grid", placeItems: "center" }}>
                      <MKBox
                        position="relative"
                        width="580px"
                        display="flex"
                        flexDirection="column"
                        borderRadius="xl"
                        bgColor="white"
                        shadow="xl"
                      >
                        {trainer.expectedPaymentDate && !trainer.expectedPaymentDate1 && !trainer.expectedPaymentDate2 && !trainer.expectedPaymentDate3 ? (
                          <>
                            <h2 style={{ whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                              Take the final step!
                            </h2>
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                Submit your payment receipt confirmation to complete the transaction successfully
                              </Typography>
                            </div>
                          </>
                        ) : (
                          <>
                            <h2 style={{ whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                              Almost there!
                            </h2>
                            <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                              <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                Please submit your payment receipt confirmation to complete the process seamlessly.
                              </Typography>
                            </div>
                          </>
                        )}
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                          <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                            Training - {trainer.trainingName} - Company - {trainer.trainingCompanyName}
                          </Typography>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px', marginTop: '20px' }}>
                          <MKButton variant="gradient" color="info" size="small" onClick={() => onPaymentNotReceivedClick(trainer)} style={{ marginRight: '10px', padding: '5px 10px' }}>Payment Not Received</MKButton>

                          <MKButton variant="gradient" color="info" size="small" onClick={() => onPaymentReceivedClick(trainer)} style={{ padding: '5px 10px' }}>Payment Received</MKButton>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginBottom: '10px' }}>
                            In case of any issues, please reach us at support@labasservice.com
                          </Typography>
                        </div>
                      </MKBox>
                    </Modal>
                  ))}
                  {trainerWithPayment20 && trainerWithPaymentStatus20.map((trainer, index) => (
                    <Modal open={true} BackdropClick="ignore" sx={{ display: "grid", placeItems: "center" }} key={index}>
                      <MKBox
                        position="relative"
                        width="600px"
                        display="flex"
                        flexDirection="column"
                        borderRadius="xl"
                        bgColor="white"
                        shadow="xl"
                      >
                        <h2 style={{ whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                          Almost there!
                        </h2>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                          <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                            Please submit your payment receipt confirmation to complete the process seamlessly.
                          </Typography>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                          <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                            Training - {trainer.trainingName} - Company - {trainer.trainingCompanyName}
                          </Typography>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                          <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                            Download your payment receipt by clicking the Download button&nbsp;
                            <MKButton variant="gradient" color="info" size="small" style={{ padding: '5px 10px' }} onClick={() => handlePaymentProofDownloadClick(trainer)}>
                              Download
                            </MKButton>
                          </Typography>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                          <MKButton variant="gradient" color="info" size="small" onClick={() => onPaymentNotReceivedClick(trainer)} style={{ marginRight: '10px', padding: '5px 10px' }}>
                            Payment Not Received
                          </MKButton>
                          <MKButton variant="gradient" color="info" size="small" onClick={() => onPaymentReceivedClick(trainer)} style={{ padding: '5px 10px' }}>
                            Payment Received
                          </MKButton>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                          <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px', marginBottom: '10px' }}>
                            In case of any issues, please reach us at support@labasservice.com
                          </Typography>
                        </div>
                      </MKBox>
                    </Modal>
                  ))}
                  <Modal open={showModal} onClose={() => onCloseApplyClick()} sx={{ display: "grid", placeItems: "center" }}>
                    <MKBox
                      position="relative"
                      width="850px"
                      display="flex"
                      flexDirection="column"
                      borderRadius="xl"
                      bgColor="white"
                      shadow="xl"
                      sx={{
                        overflowY: 'auto',
                        maxHeight: '90vh',
                      }}
                    >
                      <div>
                        <h2 style={{ whiteSpace: 'nowrap', marginLeft: '10px' }}>
                          {selectedTrainingName ? selectedTrainingName : 'Default Training Name'}
                        </h2>
                        <Grid container spacing={2}>
                          <Grid item xs={4} style={{ marginTop: "20px" }}>
                            <div>
                              <FormControl variant="outlined" style={{ width: '250px' }}>
                                <InputLabel style={{ marginLeft: "10px" }} id="select-trainingProfile-label">Select Your Training Profile *</InputLabel>
                                <Select
                                  labelId="select-trainingProfile-label"
                                  label="Select Your Training Profile *"
                                  fullWidth
                                  onChange={handleTrainingProfileChange}
                                  value={trainerProfile}
                                  style={{ minHeight: '44px', width: '250px', marginLeft: "10px" }}
                                >

                                  {trainerDetails.trainingExperience && trainerDetails.trainingExperience.map((experience, index) => (
                                    <MenuItem key={index} value={experience.profileName}>
                                      {experience.profileName}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          </Grid>
                          <Grid item xs={4} style={{ marginTop: "20px" }}>
                            <div>
                              <FormControl variant="outlined" style={{ width: '250px' }}>
                                <InputLabel id="country-currency" shrink={!!selectedCurrencyCountry}>Country *</InputLabel>
                                <Select
                                  labelId="country-currency"
                                  label="Country *"
                                  fullWidth
                                  onChange={handleCountryCurrencyChange}
                                  value={selectedCurrencyCountry}
                                  style={{ minHeight: '44px' }}
                                >
                                  {getAllISOCodes().map((country) => (
                                    <MenuItem key={country.iso} value={country.iso}>
                                      {country.countryName}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          </Grid>
                          <Grid item xs={4} style={{ marginTop: "20px" }}>
                            <div>
                              <Typography variant="subtitle2" style={{ marginTop: "10px" }}>
                                <span>Currency: {commercialsCurrency}</span>
                              </Typography>
                            </div>
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "20px", marginRight: "22px" }}>
                            <Breadcrumbs routes={[{ label: <span style={{ fontWeight: 'bold' }}>Commercials per hour</span> }]} />
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={4} style={{ marginTop: "20px" }}>
                            <div>
                              <TextField
                                label="For less than 4 hours *"
                                variant="outlined"
                                style={{ width: '250px', marginLeft: "10px" }}
                                value={commercialsLessThan4hrs}
                                onChange={(e) => setCommercialsLessThan4hrs(e.target.value)}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={4} style={{ marginTop: "20px" }}>
                            <div>
                              <TextField
                                label="For 4 hours *"
                                variant="outlined"
                                style={{ width: '250px' }}
                                value={commercials4hrs}
                                onChange={(e) => setCommercials4hrs(e.target.value)}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={4} style={{ marginTop: "20px" }}>
                            <div>
                              <TextField
                                label="For 8 hours *"
                                variant="outlined"
                                style={{ width: '250px' }}
                                value={commercials8hrs}
                                onChange={(e) => setCommercials8hrs(e.target.value)}
                              />
                            </div>
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={4} style={{ marginTop: "30px" }}>
                            <div>
                              <InputLabel style={{ marginLeft: '10px', marginTop: "-18px", marginBottom: "-5px" }} shrink={true}>
                                Last Delivered Date
                              </InputLabel>
                              <TextField
                                type="month"
                                id="lastDelivered_date"
                                value={lastDeliveredDate || ""}
                                onChange={handleLastDeliveredDateChange}
                                style={{ width: "250px", marginLeft: "10px" }}
                                InputProps={{
                                  inputProps: {
                                    max: new Date().toISOString().split('T')[0].substring(0, 7),
                                  },
                                }}
                                fullwidth
                              />
                            </div>
                          </Grid>
                          <Grid item xs={4} style={{ marginTop: "30px" }}>
                            <div>
                              <TextField
                                label="Last Delivered Client"
                                variant="outlined"
                                style={{ width: '250px' }}
                                value={lastClient}
                                onChange={(e) => setLastClient(e.target.value)}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={4} style={{ marginTop: "30px" }}>
                            <div>
                              <TextField
                                label="Training Duration (in hours) *"
                                variant="outlined"
                                style={{ width: '250px' }}
                                value={courseDuration}
                                onChange={(e) => setCourseDuration(e.target.value)}
                              />
                            </div>
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "20px", marginRight: "22px" }}>
                            <Breadcrumbs
                              routes={[{ label: "Available Dates For Training" }]}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "10px" }}>
                            <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '0.9rem' }}>
                              From When
                              <DatePicker
                                multiple
                                id="selectedDates"
                                style={{ marginLeft: '20px' }}
                                render={<CustomMultipleInput />}
                                onChange={handleTrainingAvailableChange}
                                value={trainingAvailableDate}
                                minDate={new Date()}
                              // maxDate={fbmaxDate}
                              />
                            </Typography>
                            {trainingAvailableDate.length > 0 && (
                              <Typography style={{ marginTop: '5px' }} variant="body2" fontWeight="regular">
                                <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '0.9rem' }} component="span">
                                  Selected Dates For Training:
                                </Typography>{' '}
                                {trainingAvailableDate.join(', ')}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>

                        <Grid container spacing={2}>
                          <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "20px", marginRight: "22px" }}>
                            <Breadcrumbs
                              routes={[{ label: "Available Dates For Calls" }]}
                            />
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={12} style={{ marginLeft: "10px", marginTop: "10px" }}>
                            <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '0.9rem' }}>
                              From When
                              <DatePicker
                                multiple
                                id="selectedDates"
                                style={{ marginLeft: '20px' }}
                                render={<CustomMultipleInput />}
                                onChange={handleCallAvailableDateChange}
                                value={callAvailableDate}
                                minDate={new Date()}
                              // maxDate={fbmaxDate}
                              />
                            </Typography>
                            {callAvailableDate.length > 0 && (
                              <Typography style={{ marginTop: '5px' }} variant="body2" fontWeight="regular">
                                <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', marginLeft: '10px', fontSize: '0.9rem' }} component="span">
                                  Selected Dates For Call:
                                </Typography>{' '}
                                {callAvailableDate.join(', ')}
                              </Typography>
                            )}
                          </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                          <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                            <div>
                              <TextField
                                label="Note"
                                multiline
                                rows={4}
                                variant="outlined"
                                style={{ width: '530px', marginLeft: "10px" }}
                                value={trainingComment}
                                onChange={(e) => {
                                  settrainingComment(e.target.value);
                                }}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={4} style={{ marginTop: "10px", marginLeft: "280px" }}>
                            <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', fontSize: '0.9rem' }}>
                              Is TOC available? *
                            </Typography>

                            <FormControl component="fieldset" style={{ marginLeft: '0px' }}>
                              <RadioGroup row aria-label="toc" name="selectionToc" value={selectionToc} onChange={handleTocChange}>
                                <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                  <FormControlLabel value="yes" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="Yes" />
                                  <FormControlLabel value="no" style={{ whiteSpace: 'nowrap' }} control={<Radio />} label="No" />
                                </Box>
                              </RadioGroup>
                            </FormControl>
                            {/* </Grid> */}
                            {selectionToc === 'yes' && (
                              <>
                                <Typography variant="body2" fontWeight="regular" style={{ whiteSpace: 'nowrap', fontSize: '0.9rem' }}>
                                  TOC format in .pdf, .docx, .xlsx, .xls
                                </Typography>
                                <input
                                  type="file"
                                  id="toc-upload"
                                  accept="pdf/*"
                                  style={{ display: 'none' }}
                                  ref={tocFileInputRef}
                                  onChange={handleTocUploadChange}
                                />
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                  <label htmlFor="toc-upload">
                                    <MKButton onClick={handleUploadClick} variant="gradient" color="info" size="small" style={{ whiteSpace: 'nowrap' }}>
                                      Upload TOC
                                    </MKButton>
                                  </label>
                                  {toc && (
                                    <div style={{ fontSize: '14px', marginLeft: "10px" }}>
                                      <span> {toc.name}</span>
                                    </div>
                                  )}
                                </div>
                                {tocError && (
                                  <MKTypography style={{ color: 'red', fontSize: 'small', marginLeft: '20px', marginTop: '5px' }}>
                                    {tocError}
                                  </MKTypography>
                                )}
                              </>
                            )}
                          </Grid>
                        </Grid>
                        <div style={{ display: 'flex', marginBottom: "20px", marginLeft: "10px" }}>
                          <MKButton variant="gradient" color="info" size="small" onClick={onCloseApplyClick}>
                            Cancel
                          </MKButton>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: "-50px", marginRight: "10px", marginBottom: "10px" }}>
                          <MKButton variant="gradient" color="info" size="small" disabled={!trainerProfile || !selectedCurrencyCountry || !commercialsLessThan4hrs || !commercials4hrs || !commercials8hrs || !courseDuration || !selectionToc} onClick={onSaveApplyClick}>
                            Apply
                          </MKButton>
                        </div>
                      </div>
                    </MKBox>
                  </Modal>
                  <div>
                    {trainerWith2 || trainerWith5 || trainerWith8 ? (
                      <MKAlert color="error" dismissible>
                        You have pending action to be completed. Please{' '}
                        <a
                          href="app/trainerpendingaction/"
                          style={{ marginLeft: '5px', color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(`/app/trainerpendingaction/`);
                          }}
                        >
                          click here
                        </a>{' '}
                        &nbsp;to see your pending actions.
                      </MKAlert>
                    ) : null}
                  </div>
                  <div>
                    {maxApplyCount ? (
                      <MKAlert color="error" dismissible >
                        You've reached the daily apply limit !
                      </MKAlert>
                    ) : (
                      ""
                    )}
                  </div>
                  <div>
                    {maxRemainderCount ? (
                      <MKAlert color="error" dismissible >
                        You've reached the daily remainder limit !
                      </MKAlert>
                    ) : (
                      ""
                    )}
                  </div>
                  <Dialog
                    open={recruitSubmitCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Notification !
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your response submitted to the training partner.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                      <MKButton onClick={() => { setRecruitSubmitCompleted(false); DialogProfileRecruitAcceptClose(); }} variant="contained" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitAcceptCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Notification !
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your response submitted to the training partner.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                      <Button onClick={() => { setSubmitAcceptCompleted(false); DialogProfileAcceptClose(); }} color="primary" autoFocus>
                        OK
                      </Button>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitTrainingAcceptCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Success!
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your acceptance response has been submitted to the training partner. Please await confirmation as the training partner reviews and accepts your request. Get ready for an exciting collaboration!
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                      <MKButton onClick={() => { setSubmitTrainingAcceptCompleted(false); DialogProfileTrainingAcceptClose(); }} variant="contained" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitApplyCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Fantastic news!
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your application for the training has been successfully submitted. Get ready for an enriching experience ahead!
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                      <MKButton onClick={() => { setSubmitApplyCompleted(false); DialogProfileApplyClose(); }} variant="contained" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitConfirmTrainingCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Confirmation!
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your training schedule is now officially confirmed. Prepare for a successful and enriching training experience!
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                      <MKButton onClick={() => { setSubmitConfirmTrainingCompleted(false); DialogProfileConfirmTrainingClose(); }} variant="contained" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitInvoiceSentCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Confirmation received!
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your acknowledgment of the invoice submission has been duly registered.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                      <MKButton onClick={() => { setSubmitInvoiceSentCompleted(false); DialogProfileInvoiceSentClose(); }} variant="contained" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitPaymentNotReceivedCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Success!
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        We've promptly informed the training partner about the non receipt of the payment
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                      <MKButton onClick={() => { setSubmitPaymentNotReceivedCompleted(false); DialogProfilePaymentNotReceivedClose(); }} variant="contained" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitPaymentReceivedCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Success!
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your payment receipt confirmation has been submitted to the training partner.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                      <MKButton onClick={() => { setSubmitPaymentReceivedCompleted(false); DialogProfilePaymentReceivedClose(); }} variant="contained" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={feedbackCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Notification !
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your response submitted to the training company.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                      <MKButton onClick={() => { setFeedbackCompleted(false); DialogFeebackClose(); }} variant="contained" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitRemainderCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Great news!
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Reminder sent successfully! Your gentle nudge has been delivered.
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      {/* <Button onClick={DialogClose} color="primary" autoFocus> */}
                      <MKButton onClick={() => { setSubmitRemainderCompleted(false); DialogProfileClose(); }} variant="contained" color="info" size="small" autoFocus>
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    style={{ height: "100%" }}
                    open={submitCompleted}
                    scroll={scroll}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                    fullWidth
                    maxWidth="md"
                  >
                    <DialogTitle id="alert-dialog-title">
                      Terms and Condition !
                    </DialogTitle>
                    <DialogContent dividers={scroll === "paper"}>
                      <TrainerTermsAndCondition />
                      <div style={{ marginTop: '10px' }}>
                        <input
                          type="checkbox"
                          id="agreeCheckbox"
                          checked={agreed}
                          onChange={() => setAgreed(!agreed)}
                        />
                        <label htmlFor="agreeCheckbox">
                          <strong>&nbsp;&nbsp;I agree</strong>
                        </label>
                      </div>
                    </DialogContent>
                    <DialogActions>
                      <MKButton onClick={() => {
                        if (agreed) {
                          OnOkClick();
                        } else {
                        }
                      }}
                        color="info"
                        variant="contained"
                        size="small"
                        autoFocus
                        disabled={!agreed}
                      >
                        OK
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitMobileCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    onClose={handleDialogClose}
                  >
                    <DialogTitle id="alert-dialog-title">Attention!</DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Your journey with us is just a text away. Please verify your mobile number!
                      </DialogContentText>
                      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                        <div>
                          <FormControl variant="outlined" style={{ width: '250px' }}>
                            <InputLabel id="Select Country">Select Country *</InputLabel>
                            <Select
                              labelId="Select Country "
                              label="Select Country"
                              // fullWidth
                              onChange={handleCountryChange}
                              value={selectedCountry}
                              style={{ minHeight: '44px' }}
                            >
                              {CountryList.getAll().map((country, index) => (
                                <MenuItem key={`${country.name}-${index}`} value={country.name}>
                                  {country.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                        <div>
                          <TextField
                            label="Code *"
                            name="Code"
                            value={countryCode}
                            InputProps={{
                              readOnly: true,
                            }}
                            style={{ width: '250px', minHeight: '44px' }}
                          // fullWidth
                          />
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: '20px', margin: '20px 0' }}>
                        <div>
                          <TextField
                            label="Enter Mobile Number *"
                            variant="outlined"
                            style={{ width: "520px", borderColor: mobileNumberError ? 'red' : undefined }}
                            onChange={(e) => {
                              setMobileNumber(e.target.value);
                              handleMobileNumberChange(e, setMobileNumberError);
                            }}
                            error={!mobileNumberError}
                            value={mobileNumber}
                          // fullWidth
                          />
                        </div>
                      </div>
                      <div>
                        {errorMsg ? (
                          <InputLabel style={{ marginTop: "10px", color: "red", padding: "5px" }}>{errorMsg}</InputLabel>
                        ) : (
                          ""
                        )}
                      </div>
                    </DialogContent>
                    <DialogActions>
                      <MKButton style={{ marginTop: "-20px" }}
                        onClick={handleMobNumSubmit} variant="contained" color="info"
                        disabled={!selectedCountry || !mobileNumber || !mobileNumberError}
                        autoFocus size='small'>
                        Submit
                      </MKButton>
                    </DialogActions>
                  </Dialog>
                  <Dialog
                    open={submitOTPCompleted}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    onClose={handleOTPDialogClose}
                  >
                    <DialogTitle id="alert-dialog-title">Attention Required!</DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        Validate your identity by entering the OTP received for verification.
                      </DialogContentText>
                      <div style={{ display: 'flex', marginTop: '10px' }}>
                        <div>
                          <TextField
                            label="Enter the OTP"
                            variant="outlined"
                            style={{ width: "520px" }}
                            onChange={(e) => setOtpValue(e.target.value)}
                            error={!mobileNumberError}
                            value={otpValue}
                          // fullWidth
                          />
                        </div>
                      </div>
                    </DialogContent>
                    {!otpValidated ? (
                      <DialogContent style={{ display: 'flex', justifyContent: 'right', marginTop: "-20px" }}>
                        <MKButton onClick={handleResendOTP} color="info" variant="gradient" size="small" disabled={resendDisabled}>
                          Resend OTP?
                        </MKButton>
                        <span style={{ marginLeft: '10px' }}>{formatTime(timer)}</span>
                      </DialogContent>
                    ) : (
                      ""
                    )}
                    {otpValidated ? (
                      <DialogContent>
                        <div>
                          <InputLabel style={{ marginBottom: "10px" }}>Great news! Your mobile number has been successfully validated.</InputLabel>
                          <InputLabel style={{ marginBottom: "10px" }}>You're all set to proceed!</InputLabel>
                        </div>
                      </DialogContent>
                    ) : (
                      ""
                    )}
                    <div>
                      {errorMsg && !otpValidated ? (
                        <InputLabel style={{ marginTop: "-40px", color: "red", marginLeft: "20px" }}>{errorMsg}</InputLabel>
                      ) : (
                        ""
                      )}
                    </div>
                    {otpValidated ? (
                      <DialogActions>
                        <MKButton style={{ marginTop: "-30px" }} onClick={handleOTPDialogClose} color="info" variant="contained" size="small" autoFocus>
                          OK
                        </MKButton>
                      </DialogActions>
                    ) : (
                      <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
                        <MKButton style={{ marginTop: "-30px" }} onClick={handleDialogClose} color="info" variant="contained" size="small">
                          Cancel
                        </MKButton>
                        <MKButton style={{ marginTop: "-30px" }} onClick={handleValidateSubmit} color="info" variant="contained" size="small" autoFocus>
                          Submit
                        </MKButton>
                      </DialogActions>
                    )}
                  </Dialog>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item xs={12} style={{ display: 'flex' }}>
                      <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                        <span style={{ color: 'black' }}>Accepted</span>{' '}
                        {/* <span style={{ color: 'rgb(60, 150, 190)' }}>Trainings</span> */}
                        <span style={{ color: '#2e1114' }}>Trainings</span>
                      </MKTypography>
                    </Grid>
                  </Grid>
                  {acceptedTrainings.length === 0 ? (
                    <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>No Training Partner has accepted your Training Request yet</span>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                        <Icon onClick={() => handleAcceptedScroll('left')}>keyboard_arrow_left</Icon>
                        <div
                          id="accepted-training-list-container"
                          style={{
                            display: 'flex',
                            overflowX: 'hidden', // Hide the scrollbar but allow scrolling
                            scrollBehavior: 'smooth',
                            padding: '10px',
                            width: '100%',
                            position: 'relative',
                          }}
                        >
                          {acceptedTrainings
                            .slice(acceptedCurrentSlide * 2, acceptedCurrentSlide * 2 + 2)
                            .map((training, index) => (
                              // {acceptedTrainings.map((training, index) => (
                              <div key={index} style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                                <Grid item xs={12} key={training.id} className="gridItemAcceptedTraining">
                                  <div className="gridContent" >
                                    <div className="trainingInfo">
                                      <Typography variant="subtitle1" className="trainingName"><strong>{training.trainingName}</strong></Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.technology}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />{training.trainingCompanyName}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <LocationOn style={{ marginRight: '5px' }} /> {training.trainingMode}
                                          {training.trainingMode === 'Classroom' ? ` | ${training.trainingLocations}` : ''}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          {training.finalizedCommercialsCurrency}&nbsp;{training.finalizedCommercials} |&nbsp;<img src={Expectation} alt="Expectation Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.trainingExpectation}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong> Start Date : </strong> &nbsp;{training.trainingStartDate} |&nbsp;<strong> End Date : </strong> &nbsp;{training.trainingEndDate}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong> Schedule Type : </strong> &nbsp;{training.finalizedTrainingHour}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <CalendarMonthIcon style={{ marginBottom: '5px', marginRight: '5px' }} />
                                          {training.finalizedScheduledate
                                            ? training.finalizedScheduledate
                                              .replace(/[\[\]']/g, '')
                                              .split(', ')
                                              .map((date, index, array) => (
                                                <React.Fragment key={index}>
                                                  {date}
                                                  {index < array.length - 1 && (index === 3 ? <br /> : ', ')}
                                                </React.Fragment>
                                              ))
                                            : ''}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong> Payment Date : </strong> &nbsp;{training.expectedPaymentDate3 !== null
                                            ? training.expectedPaymentDate3
                                            : training.expectedPaymentDate2 !== null
                                              ? training.expectedPaymentDate2
                                              : training.expectedPaymentDate1 !== null
                                                ? training.expectedPaymentDate1
                                                : training.expectedPaymentDate}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong> Status: {getStatusMessage(training)} </strong>
                                        </span>
                                      </Typography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onAppliedMoreDetailsClick(training)} style={{ padding: '5px 10px' }}>Details</MKButton>
                                    </div>
                                    {parseInt(training.applyTrainingStatus) === 5 && (
                                      <>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                          <MKButton variant="gradient" color="info" size="small" onClick={() => onConfirmTrainingClick(training)} style={{ padding: '5px 10px' }}>Confirm Training</MKButton>
                                        </div>
                                      </>
                                    )}
                                    {parseInt(training.applyTrainingStatus) === 8 && (
                                      <>

                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                          <MKButton variant="gradient" color="info" size="small" onClick={() => onSendInvoiceClick(training)} style={{ padding: '5px 10px' }}>Invoice Sent</MKButton>
                                        </div>
                                      </>
                                    )}
                                    {[10, 20].includes(parseInt(training.applyTrainingStatus)) && (
                                      <>
                                        <div>
                                          {getFeedbackStatus(training)}
                                          <Modal open={showFeedbackModal === true} onClose={() => setShowFeedbackModal(false)} sx={{ display: "grid", placeItems: "center" }}>
                                            <MKBox
                                              position="relative"
                                              width="780px"
                                              display="flex"
                                              flexDirection="column"
                                              borderRadius="xl"
                                              bgColor="white"
                                              shadow="xl"
                                            >
                                              <div style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                                                <h2 style={{ whiteSpace: 'nowrap', fontSize: 'large', marginLeft: '10px', marginTop: '10px' }}>
                                                  Feedback for the Training Partner {training.trainingCompanyName} for the Training - {training.trainingName}
                                                </h2>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                  <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                                    Share your rating for the Training Company * -
                                                  </Typography>
                                                  <Stack spacing={1} style={{ marginLeft: '20px', marginTop: '10px' }}>
                                                    <Rating
                                                      name="half-rating"
                                                      value={feedbackRating}
                                                      precision={0.5}
                                                      onChange={handleRatingChange}
                                                    />
                                                  </Stack>
                                                </div>
                                                <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                                  {feedbackQuestions.length > 0 && feedbackQuestions[0].question}
                                                </Typography>
                                                <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                  <div>
                                                    <TextField
                                                      label="Min: 10 characters, Max: 500 characters"
                                                      multiline
                                                      rows={4}
                                                      variant="outlined"
                                                      style={{
                                                        width: '650px', marginLeft: "20px",
                                                        borderColor: feedbackAnswer1.length >= 10 && feedbackAnswer1.length <= 500 && isFeedback1Interacted
                                                          ? "initial"
                                                          : "initial",
                                                      }}
                                                      value={feedbackAnswer1}
                                                      error={isFeedback1Interacted && (feedbackAnswer1.length < 10 || feedbackAnswer1.length > 500)}
                                                      helperText={
                                                        isFeedback1Interacted && (feedbackAnswer1.length < 10 || feedbackAnswer1.length > 500)
                                                          ? ""
                                                          : ""
                                                      }
                                                      onChange={(e) => {
                                                        setFeedbackAnswer1(e.target.value);
                                                      }}
                                                      onFocus={() => setIsFeedback1Interacted(true)}
                                                    />
                                                  </div>
                                                </Grid>
                                                <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                                  {feedbackQuestions.length > 0 && feedbackQuestions[1].question}
                                                </Typography>
                                                <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                  <div>
                                                    <TextField
                                                      label="Min: 10 characters, Max: 500 characters"
                                                      multiline
                                                      rows={4}
                                                      variant="outlined"
                                                      style={{
                                                        width: '650px', marginLeft: "20px",
                                                        borderColor: feedbackAnswer2.length >= 10 && feedbackAnswer2.length <= 500 && isFeedback2Interacted
                                                          ? "initial"
                                                          : "initial",
                                                      }}
                                                      value={feedbackAnswer2}
                                                      fullWidth
                                                      error={isFeedback2Interacted && (feedbackAnswer2.length < 10 || feedbackAnswer2.length > 500)}
                                                      helperText={
                                                        isFeedback2Interacted && (feedbackAnswer2.length < 10 || feedbackAnswer2.length > 500)
                                                          ? ""
                                                          : ""
                                                      }
                                                      onChange={(e) => {
                                                        setFeedbackAnswer2(e.target.value);
                                                      }}
                                                      onFocus={() => setIsFeedback2Interacted(true)}
                                                    />
                                                  </div>
                                                </Grid>
                                                <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                                  {feedbackQuestions.length > 0 && feedbackQuestions[2].question}
                                                </Typography>
                                                <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                  <div>
                                                    <TextField
                                                      label="Min: 10 characters, Max: 500 characters"
                                                      multiline
                                                      rows={4}
                                                      variant="outlined"
                                                      style={{
                                                        width: '650px', marginLeft: "20px",
                                                        borderColor: feedbackAnswer3.length >= 10 && feedbackAnswer3.length <= 500 && isFeedback3Interacted
                                                          ? "initial"
                                                          : "initial",
                                                      }}
                                                      value={feedbackAnswer3}
                                                      fullWidth
                                                      error={isFeedback3Interacted && (feedbackAnswer3.length < 10 || feedbackAnswer3.length > 500)}
                                                      helperText={
                                                        isFeedback3Interacted && (feedbackAnswer3.length < 10 || feedbackAnswer3.length > 500)
                                                          ? ""
                                                          : ""
                                                      }
                                                      onChange={(e) => {
                                                        setFeedbackAnswer3(e.target.value);
                                                      }}
                                                      onFocus={() => setIsFeedback3Interacted(true)}
                                                    />
                                                  </div>
                                                </Grid>
                                                <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                                  {feedbackQuestions.length > 0 && feedbackQuestions[3].question}
                                                </Typography>
                                                <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                  <div>
                                                    <TextField
                                                      label="Min: 10 characters, Max: 500 characters"
                                                      multiline
                                                      rows={4}
                                                      variant="outlined"
                                                      style={{
                                                        width: '650px', marginLeft: "20px",
                                                        borderColor: feedbackAnswer4.length >= 10 && feedbackAnswer4.length <= 500 && isFeedback4Interacted
                                                          ? "initial"
                                                          : "initial",
                                                      }}
                                                      value={feedbackAnswer4}
                                                      fullWidth
                                                      error={isFeedback4Interacted && (feedbackAnswer4.length < 10 || feedbackAnswer4.length > 500)}
                                                      helperText={
                                                        isFeedback2Interacted && (feedbackAnswer4.length < 10 || feedbackAnswer4.length > 500)
                                                          ? ""
                                                          : ""
                                                      }
                                                      onChange={(e) => {
                                                        setFeedbackAnswer4(e.target.value);
                                                      }}
                                                      onFocus={() => setIsFeedback4Interacted(true)}
                                                    />
                                                  </div>
                                                </Grid><Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                                  {feedbackQuestions.length > 0 && feedbackQuestions[4].question}
                                                </Typography>
                                                <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                  <div>
                                                    <TextField
                                                      label="Min: 10 characters, Max: 500 characters"
                                                      multiline
                                                      rows={4}
                                                      variant="outlined"
                                                      style={{
                                                        width: '650px', marginLeft: "20px",
                                                        borderColor: feedbackAnswer5.length >= 10 && feedbackAnswer5.length <= 500 && isFeedback5Interacted
                                                          ? "initial"
                                                          : "initial",
                                                      }}
                                                      value={feedbackAnswer5}
                                                      fullWidth
                                                      error={isFeedback5Interacted && (feedbackAnswer5.length < 10 || feedbackAnswer5.length > 500)}
                                                      helperText={
                                                        isFeedback5Interacted && (feedbackAnswer5.length < 10 || feedbackAnswer5.length > 500)
                                                          ? ""
                                                          : ""
                                                      }
                                                      onChange={(e) => {
                                                        setFeedbackAnswer5(e.target.value);
                                                      }}
                                                      onFocus={() => setIsFeedback5Interacted(true)}
                                                    />
                                                  </div>
                                                </Grid>
                                                <Typography style={{ fontSize: 'medium', marginLeft: '20px', marginTop: '10px' }}>
                                                  {feedbackQuestions.length > 0 && feedbackQuestions[5].question}
                                                </Typography>
                                                <Grid item xs={4} style={{ marginTop: "10px", marginBottom: "10px" }}>
                                                  <div>
                                                    <TextField
                                                      label="Min: 10 characters, Max: 500 characters"
                                                      multiline
                                                      rows={4}
                                                      variant="outlined"
                                                      style={{
                                                        width: '650px', marginLeft: "20px",
                                                        borderColor: feedbackAnswer6.length >= 10 && feedbackAnswer6.length <= 500 && isFeedback6Interacted
                                                          ? "initial"
                                                          : "initial",
                                                      }}
                                                      value={feedbackAnswer6}
                                                      fullWidth
                                                      error={isFeedback6Interacted && (feedbackAnswer6.length < 10 || feedbackAnswer6.length > 500)}
                                                      helperText={
                                                        isFeedback6Interacted && (feedbackAnswer6.length < 10 || feedbackAnswer6.length > 500)
                                                          ? ""
                                                          : ""
                                                      }
                                                      onChange={(e) => {
                                                        setFeedbackAnswer6(e.target.value);
                                                      }}
                                                      onFocus={() => setIsFeedback6Interacted(true)}
                                                    />
                                                  </div>
                                                </Grid>
                                                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
                                                  <MKButton variant="contained" color="info" size="small" disabled={!feedbackRating || !feedbackAnswer1 || feedbackAnswer1.length < 10 || feedbackAnswer1.length > 500
                                                    || !feedbackAnswer2 || feedbackAnswer2.length < 10 || feedbackAnswer2.length > 500
                                                    || !feedbackAnswer3 || feedbackAnswer3.length < 10 || feedbackAnswer3.length > 500
                                                    || !feedbackAnswer4 || feedbackAnswer4.length < 10 || feedbackAnswer4.length > 500
                                                    || !feedbackAnswer5 || feedbackAnswer5.length < 10 || feedbackAnswer5.length > 500
                                                    || !feedbackAnswer6 || feedbackAnswer6.length < 10 || feedbackAnswer6.length > 500}
                                                    onClick={() => onSubmitFeedbackClick(training)} style={{ padding: '5px 10px' }}>Submit Feedback</MKButton>
                                                </div>
                                              </div>
                                            </MKBox>
                                          </Modal>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'center', marginRight: '10px', marginTop: '-30px' }}>
                                          <MKButton variant="gradient" color="info" size="small" onClick={() => onPaymentNotReceivedClick(training)} style={{ padding: '5px 10px' }}>Payment Not Received</MKButton>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-32px' }}>
                                          <MKButton variant="gradient" color="info" size="small" onClick={() => onPaymentReceivedClick(training)} style={{ padding: '5px 10px' }}>Payment Received</MKButton>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </Grid>
                              </div>
                            ))}
                          {(acceptedTrainings.length >= 1) && (
                            <div key="see-more-card" style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                              <Grid item xs={12} className="gridItemAcceptedTraining">
                                <div className="gridContent">
                                  <div className="trainingInfo">
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      <a href="/app/traineracceptedtrainingseemore" style={{ color: 'white', textDecoration: 'underline' }}>
                                        See More
                                      </a>
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                  </div>
                                </div>
                              </Grid>
                            </div>
                          )}
                        </div>
                        <Icon onClick={() => handleAcceptedScroll('right')}>keyboard_arrow_right</Icon>
                      </div>
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item xs={12} style={{ display: 'flex' }}>
                      <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                        <span style={{ color: 'black' }}>Applied</span>{' '}
                        {/* <span style={{ color: 'rgb(60, 150, 190)' }}>Trainings</span> */}
                        <span style={{ color: '#2e1114' }}>Trainings</span>
                      </MKTypography>
                    </Grid>
                  </Grid>
                  {appliedTrainings.length === 0 ? (
                    <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>You haven't applied for any training yet</span>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                        <Icon onClick={() => handleAppliedScroll('left')}>keyboard_arrow_left</Icon>
                        <div
                          id="applied-training-list-container"
                          style={{
                            display: 'flex',
                            overflowX: 'hidden', // Hide the scrollbar but allow scrolling
                            scrollBehavior: 'smooth',
                            padding: '10px',
                            // width: '100%',
                            position: 'relative',
                          }}
                        >
                          {appliedTrainings
                            .slice(appliedCurrentSlide * 2, appliedCurrentSlide * 2 + 2)
                            .map((training, index) => (
                              // {appliedTrainings.map((training, index) => (
                              <div key={training} style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                                <Grid item xs={12} key={training.id} className="gridItem">
                                  <div className="gridContent" >
                                    <div className="trainingInfo">
                                      <Typography variant="subtitle1" className="trainingName"><strong>{training.trainingName}</strong></Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.technology}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />{training.trainingCompanyName}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <LocationOn style={{ marginRight: '5px' }} /> {training.trainingMode}
                                          {training.trainingMode === 'Classroom' ? ` | ${training.trainingLocations}` : ''}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          {training.currency}&nbsp;{training.totalTrainingBudget} |&nbsp;<img src={Expectation} alt="Expectation Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.trainingExpectation}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <CalendarMonthIcon style={{ marginRight: '5px' }} /> {training.expectedStartDate}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' }}>
                                          <strong> Status: {getStatusMessage(training)} </strong>
                                        </span>
                                      </Typography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onAppliedMoreDetailsClick(training)} style={{ padding: '5px 10px' }}>Details</MKButton>
                                      {/* <MKButton size="small" onClick={() => onAppliedMoreDetailsClick(training)} style={{ padding: '5px 10px' }}>Details</MKButton> */}
                                    </div>
                                    {parseInt(training.applyTrainingStatus) === 1 && (
                                      <>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                          <MKButton variant="gradient" color="info" size="small" onClick={() => onRemainderClick(training)} style={{ padding: '5px 10px' }}>Send Remainder</MKButton>
                                          {/* <MKButton  size="small" onClick={() => onRemainderClick(training)} style={{ padding: '5px 10px' }}>Send Remainder</MKButton> */}
                                        </div>
                                      </>
                                    )}
                                    {parseInt(training.applyTrainingStatus) === 2 && (
                                      <>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                          <MKButton variant="gradient" color="info" size="small" onClick={() => onAgreeClick(training)} style={{ padding: '5px 10px' }}>Accept</MKButton>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </Grid>
                              </div>
                            ))}
                          {(appliedTrainings.length >= 1) && (
                            <div key="see-more-card" style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                              <Grid item xs={12} className="gridItem">
                                <div className="gridContent">
                                  <div className="trainingInfo">
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      <a href="/app/trainerappliedtrainingseemore" style={{ color: 'white', textDecoration: 'underline' }}>
                                        See More
                                      </a>
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                  </div>
                                </div>
                              </Grid>
                            </div>
                          )}
                        </div>
                        <Icon onClick={() => handleAppliedScroll('right')}>keyboard_arrow_right</Icon>
                      </div>
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item xs={12} style={{ display: 'flex' }}>
                      <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                        <span style={{ color: 'black' }}>Vanquished</span>{' '}
                        {/* <span style={{ color: 'rgb(60, 150, 190)' }}>Trainings</span> */}
                        <span style={{ color: '#2e1114' }}>Trainings</span>
                      </MKTypography>
                    </Grid>
                  </Grid>
                  {vanquishedTrainings.length === 0 ? (
                    <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>No Trainings has been on-hold or vanqushied by the Training Partner</span>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                        <Icon onClick={() => handleVanquishedScroll('left')}>keyboard_arrow_left</Icon>
                        <div
                          id="vanquished-training-list-container"
                          style={{
                            display: 'flex',
                            overflowX: 'hidden', // Hide the scrollbar but allow scrolling
                            scrollBehavior: 'smooth',
                            padding: '10px',
                            width: '100%',
                            position: 'relative',
                          }}
                        >
                          {vanquishedTrainings
                            .slice(vanquishedCurrentSlide * 2, vanquishedCurrentSlide * 2 + 2)
                            .map((training, index) => (
                              // {vanquishedTrainings.map((training, index) => (
                              <div key={index} style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                                <Grid item xs={12} key={training.id} className="gridItem">
                                  <div className="gridContent">
                                    <div className="trainingInfo">
                                      <Typography variant="subtitle1" className="trainingName"><strong>{training.trainingName}</strong></Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.technology}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />{training.trainingCompanyName}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <LocationOn style={{ marginRight: '5px' }} /> {training.trainingMode}
                                          {training.trainingMode === 'Classroom' ? ` | ${training.trainingLocations}` : ''}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          {training.currency}&nbsp;{training.totalTrainingBudget} |&nbsp;<img src={Expectation} alt="Expectation Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.trainingExpectation}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <CalendarMonthIcon style={{ marginRight: '5px' }} /> {training.expectedStartDate}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong> Status: {getStatusMessage(training)} </strong>
                                        </span>
                                      </Typography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onAppliedMoreDetailsClick(training)} style={{ padding: '5px 10px' }}>Details</MKButton>
                                    </div>

                                  </div>
                                </Grid>
                              </div>
                            ))}
                          {(vanquishedTrainings.length >= 1) && (
                            <div key="see-more-card" style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                              <Grid item xs={12} className="gridItem">
                                <div className="gridContent">
                                  <div className="trainingInfo">
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      <a href="/app/trainervanquishedtrainingseemore" style={{ color: 'white', textDecoration: 'underline' }}>
                                        See More
                                      </a>
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                  </div>
                                </div>
                              </Grid>
                            </div>
                          )}
                        </div>
                        <Icon onClick={() => handleVanquishedScroll('right')}>keyboard_arrow_right</Icon>
                      </div>
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item xs={12} style={{ display: 'flex' }}>
                      <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                        <span style={{ color: 'black' }}>Completed</span>{' '}
                        {/* <span style={{ color: 'rgb(60, 150, 190)' }}>Trainings</span> */}
                        <span style={{ color: '#2e1114' }}>Trainings</span>
                      </MKTypography>
                    </Grid>
                  </Grid>
                  {completedTrainings.length === 0 ? (
                    <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>No Trainings has been completed by you.</span>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                        <Icon onClick={() => handleCompletedScroll('left')}>keyboard_arrow_left</Icon>
                        <div
                          id="completed-training-list-container"
                          style={{
                            display: 'flex',
                            overflowX: 'hidden', // Hide the scrollbar but allow scrolling
                            scrollBehavior: 'smooth',
                            padding: '10px',
                            width: '100%',
                            position: 'relative',
                          }}
                        >
                          {completedTrainings
                            .slice(completedCurrentSlide * 2, completedCurrentSlide * 2 + 2)
                            .map((training, index) => (
                              // {completedTrainings.map((training, index) => (
                              <div key={index} style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                                <Grid item xs={12} key={training.id} className="gridItemAcceptedTraining">
                                  <div className="gridContent">
                                    <div className="trainingInfo">
                                      <Typography variant="subtitle1" className="trainingName" ><strong>{training.trainingName}</strong></Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.technology}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />{training.trainingCompanyName}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <LocationOn style={{ marginRight: '5px' }} /> {training.trainingMode}
                                          {training.trainingMode === 'Classroom' ? ` | ${training.trainingLocations}` : ''}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          {training.finalizedCommercialsCurrency}&nbsp;{training.finalizedCommercials} |&nbsp;<img src={Expectation} alt="Expectation Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.trainingExpectation}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong> Start Date : </strong> &nbsp;{training.trainingStartDate} |&nbsp;<strong> End Date : </strong> &nbsp;{training.trainingEndDate}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong> Schedule Type : </strong> &nbsp;{training.finalizedTrainingHour}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <CalendarMonthIcon style={{ marginBottom: '5px', marginRight: '5px' }} />
                                          {training.finalizedScheduledate
                                            ? training.finalizedScheduledate
                                              .replace(/[\[\]']/g, '')
                                              .split(', ')
                                              .map((date, index, array) => (
                                                <React.Fragment key={index}>
                                                  {date}
                                                  {index < array.length - 1 && (index === 3 ? <br /> : ', ')}
                                                </React.Fragment>
                                              ))
                                            : ''}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong> Payment Date : </strong> &nbsp;{training.expectedPaymentDate3 !== null
                                            ? training.expectedPaymentDate3
                                            : training.expectedPaymentDate2 !== null
                                              ? training.expectedPaymentDate2
                                              : training.expectedPaymentDate1 !== null
                                                ? training.expectedPaymentDate1
                                                : training.expectedPaymentDate}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong> Status: {getStatusMessage(training)} </strong>
                                        </span>
                                      </Typography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onAppliedMoreDetailsClick(training)} style={{ padding: '5px 10px' }}>Details</MKButton>
                                    </div>

                                  </div>
                                </Grid>
                              </div>
                            ))}
                          {(completedTrainings.length >= 1) && (
                            <div key="see-more-card" style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                              <Grid item xs={12} className="gridItemAcceptedTraining">
                                <div className="gridContent">
                                  <div className="trainingInfo">
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      <a href="/app/trainercompletedtrainingseemore" style={{ color: 'white', textDecoration: 'underline' }}>
                                        See More
                                      </a>
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                  </div>
                                </div>
                              </Grid>
                            </div>
                          )}
                        </div>
                        <Icon onClick={() => handleCompletedScroll('right')}>keyboard_arrow_right</Icon>
                      </div>
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item xs={12} style={{ display: 'flex' }}>
                      <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                        <span style={{ color: 'black' }}>Recurited</span>{' '}
                        {/* <span style={{ color: 'rgb(60, 150, 190)' }}>Training Partner</span> */}
                        <span style={{ color: '#2e1114' }}>Training Partner</span>
                      </MKTypography>
                    </Grid>
                  </Grid>
                  {trainerRecruitDetails.length === 0 ? (
                    <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>You have not been recruited by any training partner at the moment.</span>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                        <Icon onClick={() => handleRecuritScroll('left')}>keyboard_arrow_left</Icon>
                        <div
                          id="recurit-training-list-container"
                          style={{
                            display: 'flex',
                            overflowX: 'hidden', // Hide the scrollbar but allow scrolling
                            scrollBehavior: 'smooth',
                            padding: '10px',
                            width: '100%',
                            position: 'relative', // Add relative position to container
                          }}
                        >
                          {trainerRecruitDetails
                            .slice(recuritCurrentSlide * 2, recuritCurrentSlide * 2 + 2)
                            .map((training, index) => (
                              // {trainerRecruitDetails.map((training, index) => (
                              <div key={index} style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                                <Grid item xs={12} key={training.id} className="gridItemRecommended">
                                  <div className="gridContent">
                                    <div className="trainingInfo">
                                      <div style={{ fontWeight: 'bold', marginTop: '-15px', marginBottom: '5px', display: 'flex', alignItems: 'center' }}>
                                        <MKAvatar
                                          src={`${process.env.REACT_APP_API_URL}${training.companyLogo}/`}
                                          alt="Profile Picture"
                                          size="lg"
                                          style={{ backgroundColor: avatarBackgroundColor, marginRight: '10px' }}
                                        />
                                        <Typography variant="subtitle1" style={{ marginTop: '0px' }}>
                                          <strong>{training.companyName}</strong>
                                        </Typography>
                                      </div>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.displaySkills}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong>Clients:&nbsp;</strong>{training.clients}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <strong>TimeZone:&nbsp;</strong>{training.supportedClientTimezone}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <strong>Status:&nbsp;{getStatus(training.trainingCompanyRecruitStatus, training.trainerAcceptStatus, training.trainingCompanyAgreeStatus)}</strong>
                                      </Typography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onRecruitedTrainingCompanyMoreDetails(training)} style={{ padding: '5px 10px' }}>Details</MKButton>
                                    </div>
                                    {getStatus(training.trainingCompanyRecruitStatus, training.trainerAcceptStatus, training.trainingCompanyAgreeStatus) === "Awaiting for Training Partner's response" && (
                                      <>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                          <MKButton variant="gradient" color="info" size="small" onClick={() => onRecruitRemainderClick(training)} style={{ padding: '5px 10px' }}>Send Remainder</MKButton>
                                        </div>
                                      </>
                                    )}
                                    {getStatus(training.trainingCompanyRecruitStatus, training.trainerAcceptStatus, training.trainingCompanyAgreeStatus) === "Awaiting for Your response" && (
                                      <>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                          <MKButton variant="gradient" color="info" size="small" onClick={() => onRecruitAgreeClick(training)} style={{ padding: '5px 10px' }}>Accept</MKButton>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </Grid>
                              </div>
                            ))}
                          {(trainerRecruitDetails.length >= 1) && (
                            <div key="see-more-card" style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                              <Grid item xs={12} className="gridItemRecommended">
                                <div className="gridContent">
                                  <div className="trainingInfo">
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      <a href="/app/trainerrecruitseemore" style={{ color: 'white', textDecoration: 'underline' }}>
                                        See More
                                      </a>
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                  </div>
                                </div>
                              </Grid>
                            </div>
                          )}
                        </div>
                        <Icon onClick={() => handleRecuritScroll('right')}>keyboard_arrow_right</Icon>
                      </div>
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Grid container spacing={2} style={{ marginBottom: "10px" }}>
                    <Grid item xs={12} style={{ display: 'flex' }}>
                      <MKTypography style={{ whiteSpace: 'nowrap' }} variant="h4" color="text">
                        <span style={{ color: 'black' }}>Recommended</span>{' '}
                        {/* <span style={{ color: 'rgb(60, 150, 190)' }}>Trainings</span> */}
                        <span style={{ color: '#2e1114' }}>Trainings</span>
                      </MKTypography>
                    </Grid>
                  </Grid>
                  {recommendedSkillsDetails.length === 0 ? (
                    <span style={{ marginLeft: "35px", marginBottom: "20px", fontSize: 'medium' }}>Improve your profile by adding or updating your skills to unlock relevant training opportunities.</span>
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                        <Icon onClick={() => handleRecommendedScroll('left')}>keyboard_arrow_left</Icon>
                        <div
                          id="recommended-training-list-container"
                          style={{
                            display: 'flex',
                            overflowX: 'hidden', // Hide the scrollbar but allow scrolling
                            scrollBehavior: 'smooth',
                            padding: '10px',
                            width: '100%',
                            position: 'relative', // Add relative position to container
                          }}
                        >
                          {recommendedSkillsDetails
                            .slice(recommendedCurrentSlide * 2, recommendedCurrentSlide * 2 + 2)
                            .map((training, index) => (
                              // {recommendedSkillsDetails.map((training, index) => (
                              <div key={index} style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                                <Grid item xs={12} key={training.id} className="gridItemRecommended">
                                  <div className="gridContent" >
                                    <div className="trainingInfo">
                                      <Typography variant="subtitle1" className="trainingName"><strong>{training.trainingName}</strong></Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={Logo} alt="Skills Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.displaySkills}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <img src={CompanyIcon} alt="Company Icon" style={{ marginRight: '5px', width: '20px', height: '20px' }} />{training.trainingCompanyName}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <LocationOn style={{ marginRight: '5px' }} /> {training.trainingMode}
                                          {training.trainingMode === 'Classroom' ? ` | ${training.trainingLocations}` : ''}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          {training.currency}&nbsp;{training.totalTrainingBudget} |&nbsp;<img src={Expectation} alt="Expectation Logo" style={{ marginRight: '5px', width: '20px', height: '20px' }} /> {training.trainingExpectation}
                                        </span>
                                      </Typography>
                                      <Typography style={{ fontSize: 'medium' }}>
                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                          <CalendarMonthIcon style={{ marginRight: '5px' }} /> {training.expectedStartDate}
                                        </span>
                                      </Typography>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-start', marginTop: '10px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onSkillsMoreDetails(training)} style={{ padding: '5px 10px' }}>Details</MKButton>
                                      {/* <MKButton  size="small" onClick={() => onSkillsMoreDetails(training)} style={{ padding: '5px 10px' }}>Details</MKButton> */}
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' }}>
                                      <MKButton variant="gradient" color="info" size="small" onClick={() => onApplyClick(training)} style={{ padding: '5px 10px' }}>Apply</MKButton>
                                      {/* <MKButton size="small" onClick={() => onApplyClick(training)} style={{ padding: '5px 10px' }}>Apply</MKButton> */}
                                    </div>
                                  </div>
                                </Grid>
                              </div>
                            ))}
                          {(recommendedSkillsDetails.length >= 1) && (
                            <div key="see-more-card" style={{ flex: '0 0 auto', marginRight: '20px', marginTop: '-10px', width: '49%' }}>
                              <Grid item xs={12} className="gridItemRecommended">
                                <div className="gridContent">
                                  <div className="trainingInfo">
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      <a href="/app/trainerrecommendedtrainingSeemore" style={{ color: 'white', textDecoration: 'underline' }}>
                                        See More
                                      </a>
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                    <MKTypography style={{ display: 'flex', justifyContent: 'center', fontSize: 'medium' }}>
                                      &nbsp;
                                    </MKTypography>
                                  </div>
                                </div>
                              </Grid>
                            </div>
                          )}
                        </div>
                        <Icon onClick={() => handleRecommendedScroll('right')}>keyboard_arrow_right</Icon>
                      </div>
                    </div>
                  )}
                </div>
              </Grid>

            </Grid>
          </Container>
        </Card>
        {/* </MKBox> */}
        <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <MKBox position="center" zIndex={2} style={{ bottom: 0 }}>
            <SimpleFooter />
          </MKBox>
        </div>
      </LoadingOverlay>
    </>
  );
};

export default Page;
